// Generated by scripts/generate-material-icon-loaders.mjs — do not edit by hand.
import type { SvgIconProps } from '@mui/material/SvgIcon';
import type { ComponentType } from 'react';

type MaterialIconModule = { default: ComponentType<SvgIconProps> };

/** Lazy loaders for non-popular icons only (popular set is in popularMaterialIcons.ts). */
export const MATERIAL_ICON_LOADERS: Record<string, () => Promise<MaterialIconModule>> = {
  Abc: () => import('@mui/icons-material/Abc'),
  AccessAlarm: () => import('@mui/icons-material/AccessAlarm'),
  AccessAlarms: () => import('@mui/icons-material/AccessAlarms'),
  AccessTimeFilled: () => import('@mui/icons-material/AccessTimeFilled'),
  Accessibility: () => import('@mui/icons-material/Accessibility'),
  AccessibilityNew: () => import('@mui/icons-material/AccessibilityNew'),
  AccessibleForward: () => import('@mui/icons-material/AccessibleForward'),
  AccountBalance: () => import('@mui/icons-material/AccountBalance'),
  AccountBalanceWallet: () => import('@mui/icons-material/AccountBalanceWallet'),
  AccountBox: () => import('@mui/icons-material/AccountBox'),
  AccountCircle: () => import('@mui/icons-material/AccountCircle'),
  AccountTree: () => import('@mui/icons-material/AccountTree'),
  AdUnits: () => import('@mui/icons-material/AdUnits'),
  Adb: () => import('@mui/icons-material/Adb'),
  AddAPhoto: () => import('@mui/icons-material/AddAPhoto'),
  AddAlarm: () => import('@mui/icons-material/AddAlarm'),
  AddAlert: () => import('@mui/icons-material/AddAlert'),
  AddBox: () => import('@mui/icons-material/AddBox'),
  AddBusiness: () => import('@mui/icons-material/AddBusiness'),
  AddCall: () => import('@mui/icons-material/AddCall'),
  AddCard: () => import('@mui/icons-material/AddCard'),
  AddCircle: () => import('@mui/icons-material/AddCircle'),
  AddComment: () => import('@mui/icons-material/AddComment'),
  AddHome: () => import('@mui/icons-material/AddHome'),
  AddHomeWork: () => import('@mui/icons-material/AddHomeWork'),
  AddIcCall: () => import('@mui/icons-material/AddIcCall'),
  AddLink: () => import('@mui/icons-material/AddLink'),
  AddLocation: () => import('@mui/icons-material/AddLocation'),
  AddLocationAlt: () => import('@mui/icons-material/AddLocationAlt'),
  AddModerator: () => import('@mui/icons-material/AddModerator'),
  AddPhotoAlternate: () => import('@mui/icons-material/AddPhotoAlternate'),
  AddReaction: () => import('@mui/icons-material/AddReaction'),
  AddRoad: () => import('@mui/icons-material/AddRoad'),
  AddShoppingCart: () => import('@mui/icons-material/AddShoppingCart'),
  AddTask: () => import('@mui/icons-material/AddTask'),
  AddToDrive: () => import('@mui/icons-material/AddToDrive'),
  AddToHomeScreen: () => import('@mui/icons-material/AddToHomeScreen'),
  AddToPhotos: () => import('@mui/icons-material/AddToPhotos'),
  AddToQueue: () => import('@mui/icons-material/AddToQueue'),
  Addchart: () => import('@mui/icons-material/Addchart'),
  AdfScanner: () => import('@mui/icons-material/AdfScanner'),
  Adjust: () => import('@mui/icons-material/Adjust'),
  AdminPanelSettings: () => import('@mui/icons-material/AdminPanelSettings'),
  AdsClick: () => import('@mui/icons-material/AdsClick'),
  Agriculture: () => import('@mui/icons-material/Agriculture'),
  Air: () => import('@mui/icons-material/Air'),
  AirlineSeatFlat: () => import('@mui/icons-material/AirlineSeatFlat'),
  AirlineSeatFlatAngled: () => import('@mui/icons-material/AirlineSeatFlatAngled'),
  AirlineSeatIndividualSuite: () => import('@mui/icons-material/AirlineSeatIndividualSuite'),
  AirlineSeatLegroomExtra: () => import('@mui/icons-material/AirlineSeatLegroomExtra'),
  AirlineSeatLegroomNormal: () => import('@mui/icons-material/AirlineSeatLegroomNormal'),
  AirlineSeatLegroomReduced: () => import('@mui/icons-material/AirlineSeatLegroomReduced'),
  AirlineSeatReclineExtra: () => import('@mui/icons-material/AirlineSeatReclineExtra'),
  AirlineSeatReclineNormal: () => import('@mui/icons-material/AirlineSeatReclineNormal'),
  AirlineStops: () => import('@mui/icons-material/AirlineStops'),
  Airlines: () => import('@mui/icons-material/Airlines'),
  AirplaneTicket: () => import('@mui/icons-material/AirplaneTicket'),
  AirplanemodeActive: () => import('@mui/icons-material/AirplanemodeActive'),
  AirplanemodeInactive: () => import('@mui/icons-material/AirplanemodeInactive'),
  Airplay: () => import('@mui/icons-material/Airplay'),
  AirportShuttle: () => import('@mui/icons-material/AirportShuttle'),
  AlarmAdd: () => import('@mui/icons-material/AlarmAdd'),
  AlarmOff: () => import('@mui/icons-material/AlarmOff'),
  AlarmOn: () => import('@mui/icons-material/AlarmOn'),
  Album: () => import('@mui/icons-material/Album'),
  AlignHorizontalCenter: () => import('@mui/icons-material/AlignHorizontalCenter'),
  AlignHorizontalLeft: () => import('@mui/icons-material/AlignHorizontalLeft'),
  AlignHorizontalRight: () => import('@mui/icons-material/AlignHorizontalRight'),
  AlignVerticalBottom: () => import('@mui/icons-material/AlignVerticalBottom'),
  AlignVerticalCenter: () => import('@mui/icons-material/AlignVerticalCenter'),
  AlignVerticalTop: () => import('@mui/icons-material/AlignVerticalTop'),
  AllInbox: () => import('@mui/icons-material/AllInbox'),
  AllInclusive: () => import('@mui/icons-material/AllInclusive'),
  AllOut: () => import('@mui/icons-material/AllOut'),
  AltRoute: () => import('@mui/icons-material/AltRoute'),
  AlternateEmail: () => import('@mui/icons-material/AlternateEmail'),
  Analytics: () => import('@mui/icons-material/Analytics'),
  Anchor: () => import('@mui/icons-material/Anchor'),
  Android: () => import('@mui/icons-material/Android'),
  Animation: () => import('@mui/icons-material/Animation'),
  Announcement: () => import('@mui/icons-material/Announcement'),
  Aod: () => import('@mui/icons-material/Aod'),
  Apartment: () => import('@mui/icons-material/Apartment'),
  Api: () => import('@mui/icons-material/Api'),
  AppBlocking: () => import('@mui/icons-material/AppBlocking'),
  AppRegistration: () => import('@mui/icons-material/AppRegistration'),
  AppSettingsAlt: () => import('@mui/icons-material/AppSettingsAlt'),
  AppShortcut: () => import('@mui/icons-material/AppShortcut'),
  Apple: () => import('@mui/icons-material/Apple'),
  Approval: () => import('@mui/icons-material/Approval'),
  Apps: () => import('@mui/icons-material/Apps'),
  AppsOutage: () => import('@mui/icons-material/AppsOutage'),
  Architecture: () => import('@mui/icons-material/Architecture'),
  Archive: () => import('@mui/icons-material/Archive'),
  AreaChart: () => import('@mui/icons-material/AreaChart'),
  ArrowBackIos: () => import('@mui/icons-material/ArrowBackIos'),
  ArrowBackIosNew: () => import('@mui/icons-material/ArrowBackIosNew'),
  ArrowCircleDown: () => import('@mui/icons-material/ArrowCircleDown'),
  ArrowCircleLeft: () => import('@mui/icons-material/ArrowCircleLeft'),
  ArrowCircleRight: () => import('@mui/icons-material/ArrowCircleRight'),
  ArrowCircleUp: () => import('@mui/icons-material/ArrowCircleUp'),
  ArrowDownward: () => import('@mui/icons-material/ArrowDownward'),
  ArrowDropDown: () => import('@mui/icons-material/ArrowDropDown'),
  ArrowDropDownCircle: () => import('@mui/icons-material/ArrowDropDownCircle'),
  ArrowDropUp: () => import('@mui/icons-material/ArrowDropUp'),
  ArrowForwardIos: () => import('@mui/icons-material/ArrowForwardIos'),
  ArrowLeft: () => import('@mui/icons-material/ArrowLeft'),
  ArrowOutward: () => import('@mui/icons-material/ArrowOutward'),
  ArrowRight: () => import('@mui/icons-material/ArrowRight'),
  ArrowRightAlt: () => import('@mui/icons-material/ArrowRightAlt'),
  ArrowUpward: () => import('@mui/icons-material/ArrowUpward'),
  ArtTrack: () => import('@mui/icons-material/ArtTrack'),
  Article: () => import('@mui/icons-material/Article'),
  AspectRatio: () => import('@mui/icons-material/AspectRatio'),
  Assessment: () => import('@mui/icons-material/Assessment'),
  Assignment: () => import('@mui/icons-material/Assignment'),
  AssignmentAdd: () => import('@mui/icons-material/AssignmentAdd'),
  AssignmentInd: () => import('@mui/icons-material/AssignmentInd'),
  AssignmentLate: () => import('@mui/icons-material/AssignmentLate'),
  AssignmentReturn: () => import('@mui/icons-material/AssignmentReturn'),
  AssignmentReturned: () => import('@mui/icons-material/AssignmentReturned'),
  AssignmentTurnedIn: () => import('@mui/icons-material/AssignmentTurnedIn'),
  AssistWalker: () => import('@mui/icons-material/AssistWalker'),
  Assistant: () => import('@mui/icons-material/Assistant'),
  AssistantDirection: () => import('@mui/icons-material/AssistantDirection'),
  AssistantNavigation: () => import('@mui/icons-material/AssistantNavigation'),
  AssistantPhoto: () => import('@mui/icons-material/AssistantPhoto'),
  AssuredWorkload: () => import('@mui/icons-material/AssuredWorkload'),
  Atm: () => import('@mui/icons-material/Atm'),
  AttachEmail: () => import('@mui/icons-material/AttachEmail'),
  AttachMoney: () => import('@mui/icons-material/AttachMoney'),
  Attachment: () => import('@mui/icons-material/Attachment'),
  Attractions: () => import('@mui/icons-material/Attractions'),
  Attribution: () => import('@mui/icons-material/Attribution'),
  AudioFile: () => import('@mui/icons-material/AudioFile'),
  Audiotrack: () => import('@mui/icons-material/Audiotrack'),
  AutoAwesome: () => import('@mui/icons-material/AutoAwesome'),
  AutoAwesomeMosaic: () => import('@mui/icons-material/AutoAwesomeMosaic'),
  AutoAwesomeMotion: () => import('@mui/icons-material/AutoAwesomeMotion'),
  AutoDelete: () => import('@mui/icons-material/AutoDelete'),
  AutoFixHigh: () => import('@mui/icons-material/AutoFixHigh'),
  AutoFixNormal: () => import('@mui/icons-material/AutoFixNormal'),
  AutoFixOff: () => import('@mui/icons-material/AutoFixOff'),
  AutoGraph: () => import('@mui/icons-material/AutoGraph'),
  AutoMode: () => import('@mui/icons-material/AutoMode'),
  AutoStories: () => import('@mui/icons-material/AutoStories'),
  AutofpsSelect: () => import('@mui/icons-material/AutofpsSelect'),
  Autorenew: () => import('@mui/icons-material/Autorenew'),
  AvTimer: () => import('@mui/icons-material/AvTimer'),
  BabyChangingStation: () => import('@mui/icons-material/BabyChangingStation'),
  BackHand: () => import('@mui/icons-material/BackHand'),
  Backpack: () => import('@mui/icons-material/Backpack'),
  Backspace: () => import('@mui/icons-material/Backspace'),
  Backup: () => import('@mui/icons-material/Backup'),
  BackupTable: () => import('@mui/icons-material/BackupTable'),
  Badge: () => import('@mui/icons-material/Badge'),
  BakeryDining: () => import('@mui/icons-material/BakeryDining'),
  Balance: () => import('@mui/icons-material/Balance'),
  Balcony: () => import('@mui/icons-material/Balcony'),
  Ballot: () => import('@mui/icons-material/Ballot'),
  BarChart: () => import('@mui/icons-material/BarChart'),
  BarcodeReader: () => import('@mui/icons-material/BarcodeReader'),
  BatchPrediction: () => import('@mui/icons-material/BatchPrediction'),
  Bathroom: () => import('@mui/icons-material/Bathroom'),
  Bathtub: () => import('@mui/icons-material/Bathtub'),
  Battery0Bar: () => import('@mui/icons-material/Battery0Bar'),
  Battery1Bar: () => import('@mui/icons-material/Battery1Bar'),
  Battery20: () => import('@mui/icons-material/Battery20'),
  Battery2Bar: () => import('@mui/icons-material/Battery2Bar'),
  Battery30: () => import('@mui/icons-material/Battery30'),
  Battery3Bar: () => import('@mui/icons-material/Battery3Bar'),
  Battery4Bar: () => import('@mui/icons-material/Battery4Bar'),
  Battery50: () => import('@mui/icons-material/Battery50'),
  Battery5Bar: () => import('@mui/icons-material/Battery5Bar'),
  Battery60: () => import('@mui/icons-material/Battery60'),
  Battery6Bar: () => import('@mui/icons-material/Battery6Bar'),
  Battery80: () => import('@mui/icons-material/Battery80'),
  Battery90: () => import('@mui/icons-material/Battery90'),
  BatteryAlert: () => import('@mui/icons-material/BatteryAlert'),
  BatteryCharging20: () => import('@mui/icons-material/BatteryCharging20'),
  BatteryCharging30: () => import('@mui/icons-material/BatteryCharging30'),
  BatteryCharging50: () => import('@mui/icons-material/BatteryCharging50'),
  BatteryCharging60: () => import('@mui/icons-material/BatteryCharging60'),
  BatteryCharging80: () => import('@mui/icons-material/BatteryCharging80'),
  BatteryCharging90: () => import('@mui/icons-material/BatteryCharging90'),
  BatteryChargingFull: () => import('@mui/icons-material/BatteryChargingFull'),
  BatteryFull: () => import('@mui/icons-material/BatteryFull'),
  BatterySaver: () => import('@mui/icons-material/BatterySaver'),
  BatteryStd: () => import('@mui/icons-material/BatteryStd'),
  BatteryUnknown: () => import('@mui/icons-material/BatteryUnknown'),
  BeachAccess: () => import('@mui/icons-material/BeachAccess'),
  Bed: () => import('@mui/icons-material/Bed'),
  BedroomBaby: () => import('@mui/icons-material/BedroomBaby'),
  BedroomChild: () => import('@mui/icons-material/BedroomChild'),
  BedroomParent: () => import('@mui/icons-material/BedroomParent'),
  Bedtime: () => import('@mui/icons-material/Bedtime'),
  BedtimeOff: () => import('@mui/icons-material/BedtimeOff'),
  Beenhere: () => import('@mui/icons-material/Beenhere'),
  Bento: () => import('@mui/icons-material/Bento'),
  BikeScooter: () => import('@mui/icons-material/BikeScooter'),
  Biotech: () => import('@mui/icons-material/Biotech'),
  Blender: () => import('@mui/icons-material/Blender'),
  Blind: () => import('@mui/icons-material/Blind'),
  Blinds: () => import('@mui/icons-material/Blinds'),
  BlindsClosed: () => import('@mui/icons-material/BlindsClosed'),
  Block: () => import('@mui/icons-material/Block'),
  BlockFlipped: () => import('@mui/icons-material/BlockFlipped'),
  Bloodtype: () => import('@mui/icons-material/Bloodtype'),
  Bluetooth: () => import('@mui/icons-material/Bluetooth'),
  BluetoothAudio: () => import('@mui/icons-material/BluetoothAudio'),
  BluetoothConnected: () => import('@mui/icons-material/BluetoothConnected'),
  BluetoothDisabled: () => import('@mui/icons-material/BluetoothDisabled'),
  BluetoothDrive: () => import('@mui/icons-material/BluetoothDrive'),
  BluetoothSearching: () => import('@mui/icons-material/BluetoothSearching'),
  BlurCircular: () => import('@mui/icons-material/BlurCircular'),
  BlurLinear: () => import('@mui/icons-material/BlurLinear'),
  BlurOff: () => import('@mui/icons-material/BlurOff'),
  BlurOn: () => import('@mui/icons-material/BlurOn'),
  Bolt: () => import('@mui/icons-material/Bolt'),
  BookOnline: () => import('@mui/icons-material/BookOnline'),
  Bookmark: () => import('@mui/icons-material/Bookmark'),
  BookmarkAdd: () => import('@mui/icons-material/BookmarkAdd'),
  BookmarkAdded: () => import('@mui/icons-material/BookmarkAdded'),
  BookmarkBorder: () => import('@mui/icons-material/BookmarkBorder'),
  BookmarkRemove: () => import('@mui/icons-material/BookmarkRemove'),
  Bookmarks: () => import('@mui/icons-material/Bookmarks'),
  BorderAll: () => import('@mui/icons-material/BorderAll'),
  BorderBottom: () => import('@mui/icons-material/BorderBottom'),
  BorderClear: () => import('@mui/icons-material/BorderClear'),
  BorderColor: () => import('@mui/icons-material/BorderColor'),
  BorderHorizontal: () => import('@mui/icons-material/BorderHorizontal'),
  BorderInner: () => import('@mui/icons-material/BorderInner'),
  BorderLeft: () => import('@mui/icons-material/BorderLeft'),
  BorderOuter: () => import('@mui/icons-material/BorderOuter'),
  BorderRight: () => import('@mui/icons-material/BorderRight'),
  BorderStyle: () => import('@mui/icons-material/BorderStyle'),
  BorderTop: () => import('@mui/icons-material/BorderTop'),
  BorderVertical: () => import('@mui/icons-material/BorderVertical'),
  Boy: () => import('@mui/icons-material/Boy'),
  BrandingWatermark: () => import('@mui/icons-material/BrandingWatermark'),
  BreakfastDining: () => import('@mui/icons-material/BreakfastDining'),
  Brightness1: () => import('@mui/icons-material/Brightness1'),
  Brightness2: () => import('@mui/icons-material/Brightness2'),
  Brightness3: () => import('@mui/icons-material/Brightness3'),
  Brightness4: () => import('@mui/icons-material/Brightness4'),
  Brightness5: () => import('@mui/icons-material/Brightness5'),
  Brightness6: () => import('@mui/icons-material/Brightness6'),
  Brightness7: () => import('@mui/icons-material/Brightness7'),
  BrightnessAuto: () => import('@mui/icons-material/BrightnessAuto'),
  BrightnessHigh: () => import('@mui/icons-material/BrightnessHigh'),
  BrightnessLow: () => import('@mui/icons-material/BrightnessLow'),
  BrightnessMedium: () => import('@mui/icons-material/BrightnessMedium'),
  BroadcastOnHome: () => import('@mui/icons-material/BroadcastOnHome'),
  BroadcastOnPersonal: () => import('@mui/icons-material/BroadcastOnPersonal'),
  BrokenImage: () => import('@mui/icons-material/BrokenImage'),
  BrowseGallery: () => import('@mui/icons-material/BrowseGallery'),
  BrowserNotSupported: () => import('@mui/icons-material/BrowserNotSupported'),
  BrowserUpdated: () => import('@mui/icons-material/BrowserUpdated'),
  BrunchDining: () => import('@mui/icons-material/BrunchDining'),
  Brush: () => import('@mui/icons-material/Brush'),
  BubbleChart: () => import('@mui/icons-material/BubbleChart'),
  BugReport: () => import('@mui/icons-material/BugReport'),
  BuildCircle: () => import('@mui/icons-material/BuildCircle'),
  Bungalow: () => import('@mui/icons-material/Bungalow'),
  BurstMode: () => import('@mui/icons-material/BurstMode'),
  BusAlert: () => import('@mui/icons-material/BusAlert'),
  Business: () => import('@mui/icons-material/Business'),
  BusinessCenter: () => import('@mui/icons-material/BusinessCenter'),
  Cabin: () => import('@mui/icons-material/Cabin'),
  Cable: () => import('@mui/icons-material/Cable'),
  Cached: () => import('@mui/icons-material/Cached'),
  Cake: () => import('@mui/icons-material/Cake'),
  Calculate: () => import('@mui/icons-material/Calculate'),
  CalendarMonth: () => import('@mui/icons-material/CalendarMonth'),
  CalendarViewDay: () => import('@mui/icons-material/CalendarViewDay'),
  CalendarViewMonth: () => import('@mui/icons-material/CalendarViewMonth'),
  CalendarViewWeek: () => import('@mui/icons-material/CalendarViewWeek'),
  CallEnd: () => import('@mui/icons-material/CallEnd'),
  CallMade: () => import('@mui/icons-material/CallMade'),
  CallMerge: () => import('@mui/icons-material/CallMerge'),
  CallMissed: () => import('@mui/icons-material/CallMissed'),
  CallMissedOutgoing: () => import('@mui/icons-material/CallMissedOutgoing'),
  CallReceived: () => import('@mui/icons-material/CallReceived'),
  CallSplit: () => import('@mui/icons-material/CallSplit'),
  CallToAction: () => import('@mui/icons-material/CallToAction'),
  Camera: () => import('@mui/icons-material/Camera'),
  CameraAlt: () => import('@mui/icons-material/CameraAlt'),
  CameraEnhance: () => import('@mui/icons-material/CameraEnhance'),
  CameraFront: () => import('@mui/icons-material/CameraFront'),
  CameraIndoor: () => import('@mui/icons-material/CameraIndoor'),
  CameraOutdoor: () => import('@mui/icons-material/CameraOutdoor'),
  CameraRear: () => import('@mui/icons-material/CameraRear'),
  CameraRoll: () => import('@mui/icons-material/CameraRoll'),
  Cameraswitch: () => import('@mui/icons-material/Cameraswitch'),
  CancelPresentation: () => import('@mui/icons-material/CancelPresentation'),
  CancelScheduleSend: () => import('@mui/icons-material/CancelScheduleSend'),
  CandlestickChart: () => import('@mui/icons-material/CandlestickChart'),
  CarCrash: () => import('@mui/icons-material/CarCrash'),
  CarRental: () => import('@mui/icons-material/CarRental'),
  CarRepair: () => import('@mui/icons-material/CarRepair'),
  CardGiftcard: () => import('@mui/icons-material/CardGiftcard'),
  CardMembership: () => import('@mui/icons-material/CardMembership'),
  CardTravel: () => import('@mui/icons-material/CardTravel'),
  Carpenter: () => import('@mui/icons-material/Carpenter'),
  Cases: () => import('@mui/icons-material/Cases'),
  Casino: () => import('@mui/icons-material/Casino'),
  Cast: () => import('@mui/icons-material/Cast'),
  CastConnected: () => import('@mui/icons-material/CastConnected'),
  CastForEducation: () => import('@mui/icons-material/CastForEducation'),
  Castle: () => import('@mui/icons-material/Castle'),
  CatchingPokemon: () => import('@mui/icons-material/CatchingPokemon'),
  Category: () => import('@mui/icons-material/Category'),
  Celebration: () => import('@mui/icons-material/Celebration'),
  CellTower: () => import('@mui/icons-material/CellTower'),
  CellWifi: () => import('@mui/icons-material/CellWifi'),
  CenterFocusStrong: () => import('@mui/icons-material/CenterFocusStrong'),
  CenterFocusWeak: () => import('@mui/icons-material/CenterFocusWeak'),
  Chair: () => import('@mui/icons-material/Chair'),
  ChairAlt: () => import('@mui/icons-material/ChairAlt'),
  Chalet: () => import('@mui/icons-material/Chalet'),
  ChangeCircle: () => import('@mui/icons-material/ChangeCircle'),
  ChangeHistory: () => import('@mui/icons-material/ChangeHistory'),
  ChargingStation: () => import('@mui/icons-material/ChargingStation'),
  Chat: () => import('@mui/icons-material/Chat'),
  ChatBubble: () => import('@mui/icons-material/ChatBubble'),
  CheckBox: () => import('@mui/icons-material/CheckBox'),
  CheckBoxOutlineBlank: () => import('@mui/icons-material/CheckBoxOutlineBlank'),
  Checklist: () => import('@mui/icons-material/Checklist'),
  ChecklistRtl: () => import('@mui/icons-material/ChecklistRtl'),
  Checkroom: () => import('@mui/icons-material/Checkroom'),
  ChevronLeft: () => import('@mui/icons-material/ChevronLeft'),
  ChevronRight: () => import('@mui/icons-material/ChevronRight'),
  ChildCare: () => import('@mui/icons-material/ChildCare'),
  ChildFriendly: () => import('@mui/icons-material/ChildFriendly'),
  ChromeReaderMode: () => import('@mui/icons-material/ChromeReaderMode'),
  Church: () => import('@mui/icons-material/Church'),
  Circle: () => import('@mui/icons-material/Circle'),
  CircleNotifications: () => import('@mui/icons-material/CircleNotifications'),
  Class: () => import('@mui/icons-material/Class'),
  CleanHands: () => import('@mui/icons-material/CleanHands'),
  CleaningServices: () => import('@mui/icons-material/CleaningServices'),
  Clear: () => import('@mui/icons-material/Clear'),
  ClearAll: () => import('@mui/icons-material/ClearAll'),
  CloseFullscreen: () => import('@mui/icons-material/CloseFullscreen'),
  ClosedCaption: () => import('@mui/icons-material/ClosedCaption'),
  ClosedCaptionDisabled: () => import('@mui/icons-material/ClosedCaptionDisabled'),
  ClosedCaptionOff: () => import('@mui/icons-material/ClosedCaptionOff'),
  CloudCircle: () => import('@mui/icons-material/CloudCircle'),
  CloudDone: () => import('@mui/icons-material/CloudDone'),
  CloudDownload: () => import('@mui/icons-material/CloudDownload'),
  CloudOff: () => import('@mui/icons-material/CloudOff'),
  CloudQueue: () => import('@mui/icons-material/CloudQueue'),
  CloudSync: () => import('@mui/icons-material/CloudSync'),
  CloudUpload: () => import('@mui/icons-material/CloudUpload'),
  CloudySnowing: () => import('@mui/icons-material/CloudySnowing'),
  Co2: () => import('@mui/icons-material/Co2'),
  CoPresent: () => import('@mui/icons-material/CoPresent'),
  Code: () => import('@mui/icons-material/Code'),
  CodeOff: () => import('@mui/icons-material/CodeOff'),
  Coffee: () => import('@mui/icons-material/Coffee'),
  CoffeeMaker: () => import('@mui/icons-material/CoffeeMaker'),
  Collections: () => import('@mui/icons-material/Collections'),
  CollectionsBookmark: () => import('@mui/icons-material/CollectionsBookmark'),
  ColorLens: () => import('@mui/icons-material/ColorLens'),
  Colorize: () => import('@mui/icons-material/Colorize'),
  Comment: () => import('@mui/icons-material/Comment'),
  CommentBank: () => import('@mui/icons-material/CommentBank'),
  CommentsDisabled: () => import('@mui/icons-material/CommentsDisabled'),
  Commit: () => import('@mui/icons-material/Commit'),
  Commute: () => import('@mui/icons-material/Commute'),
  Compare: () => import('@mui/icons-material/Compare'),
  CompareArrows: () => import('@mui/icons-material/CompareArrows'),
  CompassCalibration: () => import('@mui/icons-material/CompassCalibration'),
  Compost: () => import('@mui/icons-material/Compost'),
  Compress: () => import('@mui/icons-material/Compress'),
  Computer: () => import('@mui/icons-material/Computer'),
  ConfirmationNumber: () => import('@mui/icons-material/ConfirmationNumber'),
  ConnectWithoutContact: () => import('@mui/icons-material/ConnectWithoutContact'),
  ConnectedTv: () => import('@mui/icons-material/ConnectedTv'),
  ConnectingAirports: () => import('@mui/icons-material/ConnectingAirports'),
  ContactEmergency: () => import('@mui/icons-material/ContactEmergency'),
  ContactMail: () => import('@mui/icons-material/ContactMail'),
  ContactPage: () => import('@mui/icons-material/ContactPage'),
  ContactPhone: () => import('@mui/icons-material/ContactPhone'),
  ContactSupport: () => import('@mui/icons-material/ContactSupport'),
  Contactless: () => import('@mui/icons-material/Contactless'),
  Contacts: () => import('@mui/icons-material/Contacts'),
  ContentCopy: () => import('@mui/icons-material/ContentCopy'),
  ContentCut: () => import('@mui/icons-material/ContentCut'),
  ContentPaste: () => import('@mui/icons-material/ContentPaste'),
  ContentPasteGo: () => import('@mui/icons-material/ContentPasteGo'),
  ContentPasteOff: () => import('@mui/icons-material/ContentPasteOff'),
  ContentPasteSearch: () => import('@mui/icons-material/ContentPasteSearch'),
  Contrast: () => import('@mui/icons-material/Contrast'),
  ControlCamera: () => import('@mui/icons-material/ControlCamera'),
  ControlPoint: () => import('@mui/icons-material/ControlPoint'),
  ControlPointDuplicate: () => import('@mui/icons-material/ControlPointDuplicate'),
  ConveyorBelt: () => import('@mui/icons-material/ConveyorBelt'),
  Cookie: () => import('@mui/icons-material/Cookie'),
  CopyAll: () => import('@mui/icons-material/CopyAll'),
  Copyright: () => import('@mui/icons-material/Copyright'),
  Coronavirus: () => import('@mui/icons-material/Coronavirus'),
  CorporateFare: () => import('@mui/icons-material/CorporateFare'),
  Cottage: () => import('@mui/icons-material/Cottage'),
  Countertops: () => import('@mui/icons-material/Countertops'),
  CreateNewFolder: () => import('@mui/icons-material/CreateNewFolder'),
  CreditCardOff: () => import('@mui/icons-material/CreditCardOff'),
  CreditScore: () => import('@mui/icons-material/CreditScore'),
  Crib: () => import('@mui/icons-material/Crib'),
  CrisisAlert: () => import('@mui/icons-material/CrisisAlert'),
  Crop: () => import('@mui/icons-material/Crop'),
  Crop169: () => import('@mui/icons-material/Crop169'),
  Crop32: () => import('@mui/icons-material/Crop32'),
  Crop54: () => import('@mui/icons-material/Crop54'),
  Crop75: () => import('@mui/icons-material/Crop75'),
  CropDin: () => import('@mui/icons-material/CropDin'),
  CropFree: () => import('@mui/icons-material/CropFree'),
  CropLandscape: () => import('@mui/icons-material/CropLandscape'),
  CropOriginal: () => import('@mui/icons-material/CropOriginal'),
  CropPortrait: () => import('@mui/icons-material/CropPortrait'),
  CropRotate: () => import('@mui/icons-material/CropRotate'),
  CropSquare: () => import('@mui/icons-material/CropSquare'),
  CrueltyFree: () => import('@mui/icons-material/CrueltyFree'),
  Css: () => import('@mui/icons-material/Css'),
  CurrencyBitcoin: () => import('@mui/icons-material/CurrencyBitcoin'),
  CurrencyExchange: () => import('@mui/icons-material/CurrencyExchange'),
  CurrencyFranc: () => import('@mui/icons-material/CurrencyFranc'),
  CurrencyLira: () => import('@mui/icons-material/CurrencyLira'),
  CurrencyPound: () => import('@mui/icons-material/CurrencyPound'),
  CurrencyRuble: () => import('@mui/icons-material/CurrencyRuble'),
  CurrencyRupee: () => import('@mui/icons-material/CurrencyRupee'),
  CurrencyYen: () => import('@mui/icons-material/CurrencyYen'),
  CurrencyYuan: () => import('@mui/icons-material/CurrencyYuan'),
  Curtains: () => import('@mui/icons-material/Curtains'),
  CurtainsClosed: () => import('@mui/icons-material/CurtainsClosed'),
  Cyclone: () => import('@mui/icons-material/Cyclone'),
  Dangerous: () => import('@mui/icons-material/Dangerous'),
  DarkMode: () => import('@mui/icons-material/DarkMode'),
  Dashboard: () => import('@mui/icons-material/Dashboard'),
  DashboardCustomize: () => import('@mui/icons-material/DashboardCustomize'),
  DataArray: () => import('@mui/icons-material/DataArray'),
  DataExploration: () => import('@mui/icons-material/DataExploration'),
  DataObject: () => import('@mui/icons-material/DataObject'),
  DataSaverOff: () => import('@mui/icons-material/DataSaverOff'),
  DataSaverOn: () => import('@mui/icons-material/DataSaverOn'),
  DataThresholding: () => import('@mui/icons-material/DataThresholding'),
  DataUsage: () => import('@mui/icons-material/DataUsage'),
  Dataset: () => import('@mui/icons-material/Dataset'),
  DatasetLinked: () => import('@mui/icons-material/DatasetLinked'),
  DateRange: () => import('@mui/icons-material/DateRange'),
  Deblur: () => import('@mui/icons-material/Deblur'),
  Deck: () => import('@mui/icons-material/Deck'),
  Dehaze: () => import('@mui/icons-material/Dehaze'),
  DeleteForever: () => import('@mui/icons-material/DeleteForever'),
  DeleteSweep: () => import('@mui/icons-material/DeleteSweep'),
  DeliveryDining: () => import('@mui/icons-material/DeliveryDining'),
  DensityLarge: () => import('@mui/icons-material/DensityLarge'),
  DensityMedium: () => import('@mui/icons-material/DensityMedium'),
  DensitySmall: () => import('@mui/icons-material/DensitySmall'),
  DepartureBoard: () => import('@mui/icons-material/DepartureBoard'),
  Description: () => import('@mui/icons-material/Description'),
  Deselect: () => import('@mui/icons-material/Deselect'),
  DesignServices: () => import('@mui/icons-material/DesignServices'),
  Desk: () => import('@mui/icons-material/Desk'),
  DesktopAccessDisabled: () => import('@mui/icons-material/DesktopAccessDisabled'),
  DesktopMac: () => import('@mui/icons-material/DesktopMac'),
  DesktopWindows: () => import('@mui/icons-material/DesktopWindows'),
  Details: () => import('@mui/icons-material/Details'),
  DeveloperBoard: () => import('@mui/icons-material/DeveloperBoard'),
  DeveloperBoardOff: () => import('@mui/icons-material/DeveloperBoardOff'),
  DeveloperMode: () => import('@mui/icons-material/DeveloperMode'),
  DeviceHub: () => import('@mui/icons-material/DeviceHub'),
  DeviceThermostat: () => import('@mui/icons-material/DeviceThermostat'),
  DeviceUnknown: () => import('@mui/icons-material/DeviceUnknown'),
  Devices: () => import('@mui/icons-material/Devices'),
  DevicesFold: () => import('@mui/icons-material/DevicesFold'),
  DevicesOther: () => import('@mui/icons-material/DevicesOther'),
  DewPoint: () => import('@mui/icons-material/DewPoint'),
  DialerSip: () => import('@mui/icons-material/DialerSip'),
  Dialpad: () => import('@mui/icons-material/Dialpad'),
  Diamond: () => import('@mui/icons-material/Diamond'),
  Difference: () => import('@mui/icons-material/Difference'),
  Dining: () => import('@mui/icons-material/Dining'),
  DinnerDining: () => import('@mui/icons-material/DinnerDining'),
  DirectionsBoat: () => import('@mui/icons-material/DirectionsBoat'),
  DirectionsBoatFilled: () => import('@mui/icons-material/DirectionsBoatFilled'),
  DirectionsBus: () => import('@mui/icons-material/DirectionsBus'),
  DirectionsBusFilled: () => import('@mui/icons-material/DirectionsBusFilled'),
  DirectionsCar: () => import('@mui/icons-material/DirectionsCar'),
  DirectionsCarFilled: () => import('@mui/icons-material/DirectionsCarFilled'),
  DirectionsOff: () => import('@mui/icons-material/DirectionsOff'),
  DirectionsRailway: () => import('@mui/icons-material/DirectionsRailway'),
  DirectionsRailwayFilled: () => import('@mui/icons-material/DirectionsRailwayFilled'),
  DirectionsSubway: () => import('@mui/icons-material/DirectionsSubway'),
  DirectionsSubwayFilled: () => import('@mui/icons-material/DirectionsSubwayFilled'),
  DirectionsTransit: () => import('@mui/icons-material/DirectionsTransit'),
  DirectionsTransitFilled: () => import('@mui/icons-material/DirectionsTransitFilled'),
  DirtyLens: () => import('@mui/icons-material/DirtyLens'),
  DisabledByDefault: () => import('@mui/icons-material/DisabledByDefault'),
  DisabledVisible: () => import('@mui/icons-material/DisabledVisible'),
  DiscFull: () => import('@mui/icons-material/DiscFull'),
  Discount: () => import('@mui/icons-material/Discount'),
  DisplaySettings: () => import('@mui/icons-material/DisplaySettings'),
  Diversity1: () => import('@mui/icons-material/Diversity1'),
  Diversity2: () => import('@mui/icons-material/Diversity2'),
  Diversity3: () => import('@mui/icons-material/Diversity3'),
  Dns: () => import('@mui/icons-material/Dns'),
  DoDisturb: () => import('@mui/icons-material/DoDisturb'),
  DoDisturbAlt: () => import('@mui/icons-material/DoDisturbAlt'),
  DoDisturbOff: () => import('@mui/icons-material/DoDisturbOff'),
  DoDisturbOn: () => import('@mui/icons-material/DoDisturbOn'),
  DoNotDisturb: () => import('@mui/icons-material/DoNotDisturb'),
  DoNotDisturbAlt: () => import('@mui/icons-material/DoNotDisturbAlt'),
  DoNotDisturbOff: () => import('@mui/icons-material/DoNotDisturbOff'),
  DoNotDisturbOn: () => import('@mui/icons-material/DoNotDisturbOn'),
  DoNotDisturbOnTotalSilence: () => import('@mui/icons-material/DoNotDisturbOnTotalSilence'),
  DoNotStep: () => import('@mui/icons-material/DoNotStep'),
  DoNotTouch: () => import('@mui/icons-material/DoNotTouch'),
  Dock: () => import('@mui/icons-material/Dock'),
  DocumentScanner: () => import('@mui/icons-material/DocumentScanner'),
  Domain: () => import('@mui/icons-material/Domain'),
  DomainAdd: () => import('@mui/icons-material/DomainAdd'),
  DomainDisabled: () => import('@mui/icons-material/DomainDisabled'),
  DomainVerification: () => import('@mui/icons-material/DomainVerification'),
  Done: () => import('@mui/icons-material/Done'),
  DoneAll: () => import('@mui/icons-material/DoneAll'),
  DonutLarge: () => import('@mui/icons-material/DonutLarge'),
  DonutSmall: () => import('@mui/icons-material/DonutSmall'),
  DoorBack: () => import('@mui/icons-material/DoorBack'),
  DoorFront: () => import('@mui/icons-material/DoorFront'),
  DoorSliding: () => import('@mui/icons-material/DoorSliding'),
  Doorbell: () => import('@mui/icons-material/Doorbell'),
  DoubleArrow: () => import('@mui/icons-material/DoubleArrow'),
  DownhillSkiing: () => import('@mui/icons-material/DownhillSkiing'),
  DownloadDone: () => import('@mui/icons-material/DownloadDone'),
  DownloadForOffline: () => import('@mui/icons-material/DownloadForOffline'),
  Downloading: () => import('@mui/icons-material/Downloading'),
  DragHandle: () => import('@mui/icons-material/DragHandle'),
  DragIndicator: () => import('@mui/icons-material/DragIndicator'),
  Draw: () => import('@mui/icons-material/Draw'),
  DriveEta: () => import('@mui/icons-material/DriveEta'),
  DriveFileMove: () => import('@mui/icons-material/DriveFileMove'),
  DriveFileMoveRtl: () => import('@mui/icons-material/DriveFileMoveRtl'),
  DriveFileRenameOutline: () => import('@mui/icons-material/DriveFileRenameOutline'),
  DriveFolderUpload: () => import('@mui/icons-material/DriveFolderUpload'),
  Dry: () => import('@mui/icons-material/Dry'),
  DryCleaning: () => import('@mui/icons-material/DryCleaning'),
  Duo: () => import('@mui/icons-material/Duo'),
  Dvr: () => import('@mui/icons-material/Dvr'),
  DynamicFeed: () => import('@mui/icons-material/DynamicFeed'),
  DynamicForm: () => import('@mui/icons-material/DynamicForm'),
  EMobiledata: () => import('@mui/icons-material/EMobiledata'),
  Earbuds: () => import('@mui/icons-material/Earbuds'),
  EarbudsBattery: () => import('@mui/icons-material/EarbudsBattery'),
  East: () => import('@mui/icons-material/East'),
  EdgesensorHigh: () => import('@mui/icons-material/EdgesensorHigh'),
  EdgesensorLow: () => import('@mui/icons-material/EdgesensorLow'),
  EditAttributes: () => import('@mui/icons-material/EditAttributes'),
  EditCalendar: () => import('@mui/icons-material/EditCalendar'),
  EditDocument: () => import('@mui/icons-material/EditDocument'),
  EditLocation: () => import('@mui/icons-material/EditLocation'),
  EditLocationAlt: () => import('@mui/icons-material/EditLocationAlt'),
  EditNote: () => import('@mui/icons-material/EditNote'),
  EditNotifications: () => import('@mui/icons-material/EditNotifications'),
  EditOff: () => import('@mui/icons-material/EditOff'),
  EditRoad: () => import('@mui/icons-material/EditRoad'),
  EditSquare: () => import('@mui/icons-material/EditSquare'),
  Egg: () => import('@mui/icons-material/Egg'),
  EggAlt: () => import('@mui/icons-material/EggAlt'),
  EightK: () => import('@mui/icons-material/EightK'),
  EightKPlus: () => import('@mui/icons-material/EightKPlus'),
  EightMp: () => import('@mui/icons-material/EightMp'),
  EighteenMp: () => import('@mui/icons-material/EighteenMp'),
  EighteenUpRating: () => import('@mui/icons-material/EighteenUpRating'),
  EightteenMp: () => import('@mui/icons-material/EightteenMp'),
  Eject: () => import('@mui/icons-material/Eject'),
  Elderly: () => import('@mui/icons-material/Elderly'),
  ElderlyWoman: () => import('@mui/icons-material/ElderlyWoman'),
  ElectricBike: () => import('@mui/icons-material/ElectricBike'),
  ElectricBolt: () => import('@mui/icons-material/ElectricBolt'),
  ElectricCar: () => import('@mui/icons-material/ElectricCar'),
  ElectricMeter: () => import('@mui/icons-material/ElectricMeter'),
  ElectricMoped: () => import('@mui/icons-material/ElectricMoped'),
  ElectricRickshaw: () => import('@mui/icons-material/ElectricRickshaw'),
  ElectricScooter: () => import('@mui/icons-material/ElectricScooter'),
  ElectricalServices: () => import('@mui/icons-material/ElectricalServices'),
  Elevator: () => import('@mui/icons-material/Elevator'),
  ElevenMp: () => import('@mui/icons-material/ElevenMp'),
  Emergency: () => import('@mui/icons-material/Emergency'),
  EmergencyRecording: () => import('@mui/icons-material/EmergencyRecording'),
  EmergencyShare: () => import('@mui/icons-material/EmergencyShare'),
  EmojiEmotions: () => import('@mui/icons-material/EmojiEmotions'),
  EmojiFlags: () => import('@mui/icons-material/EmojiFlags'),
  EmojiFoodBeverage: () => import('@mui/icons-material/EmojiFoodBeverage'),
  EmojiNature: () => import('@mui/icons-material/EmojiNature'),
  EmojiObjects: () => import('@mui/icons-material/EmojiObjects'),
  EmojiPeople: () => import('@mui/icons-material/EmojiPeople'),
  EmojiSymbols: () => import('@mui/icons-material/EmojiSymbols'),
  EmojiTransportation: () => import('@mui/icons-material/EmojiTransportation'),
  EnergySavingsLeaf: () => import('@mui/icons-material/EnergySavingsLeaf'),
  Engineering: () => import('@mui/icons-material/Engineering'),
  EnhancedEncryption: () => import('@mui/icons-material/EnhancedEncryption'),
  Equalizer: () => import('@mui/icons-material/Equalizer'),
  Escalator: () => import('@mui/icons-material/Escalator'),
  EscalatorWarning: () => import('@mui/icons-material/EscalatorWarning'),
  Euro: () => import('@mui/icons-material/Euro'),
  EuroSymbol: () => import('@mui/icons-material/EuroSymbol'),
  EvStation: () => import('@mui/icons-material/EvStation'),
  EventAvailable: () => import('@mui/icons-material/EventAvailable'),
  EventBusy: () => import('@mui/icons-material/EventBusy'),
  EventNote: () => import('@mui/icons-material/EventNote'),
  EventRepeat: () => import('@mui/icons-material/EventRepeat'),
  EventSeat: () => import('@mui/icons-material/EventSeat'),
  ExitToApp: () => import('@mui/icons-material/ExitToApp'),
  Expand: () => import('@mui/icons-material/Expand'),
  ExpandCircleDown: () => import('@mui/icons-material/ExpandCircleDown'),
  Explicit: () => import('@mui/icons-material/Explicit'),
  Explore: () => import('@mui/icons-material/Explore'),
  ExploreOff: () => import('@mui/icons-material/ExploreOff'),
  Exposure: () => import('@mui/icons-material/Exposure'),
  Extension: () => import('@mui/icons-material/Extension'),
  ExtensionOff: () => import('@mui/icons-material/ExtensionOff'),
  Face: () => import('@mui/icons-material/Face'),
  Face2: () => import('@mui/icons-material/Face2'),
  Face3: () => import('@mui/icons-material/Face3'),
  Face4: () => import('@mui/icons-material/Face4'),
  Face5: () => import('@mui/icons-material/Face5'),
  Face6: () => import('@mui/icons-material/Face6'),
  FaceRetouchingNatural: () => import('@mui/icons-material/FaceRetouchingNatural'),
  FaceRetouchingOff: () => import('@mui/icons-material/FaceRetouchingOff'),
  Facebook: () => import('@mui/icons-material/Facebook'),
  FactCheck: () => import('@mui/icons-material/FactCheck'),
  Factory: () => import('@mui/icons-material/Factory'),
  FamilyRestroom: () => import('@mui/icons-material/FamilyRestroom'),
  FastForward: () => import('@mui/icons-material/FastForward'),
  FastRewind: () => import('@mui/icons-material/FastRewind'),
  Fastfood: () => import('@mui/icons-material/Fastfood'),
  Fax: () => import('@mui/icons-material/Fax'),
  FeaturedPlayList: () => import('@mui/icons-material/FeaturedPlayList'),
  FeaturedVideo: () => import('@mui/icons-material/FeaturedVideo'),
  Feed: () => import('@mui/icons-material/Feed'),
  Feedback: () => import('@mui/icons-material/Feedback'),
  Female: () => import('@mui/icons-material/Female'),
  Fence: () => import('@mui/icons-material/Fence'),
  Festival: () => import('@mui/icons-material/Festival'),
  FiberDvr: () => import('@mui/icons-material/FiberDvr'),
  FiberManualRecord: () => import('@mui/icons-material/FiberManualRecord'),
  FiberNew: () => import('@mui/icons-material/FiberNew'),
  FiberPin: () => import('@mui/icons-material/FiberPin'),
  FiberSmartRecord: () => import('@mui/icons-material/FiberSmartRecord'),
  FifteenMp: () => import('@mui/icons-material/FifteenMp'),
  FileCopy: () => import('@mui/icons-material/FileCopy'),
  FileDownload: () => import('@mui/icons-material/FileDownload'),
  FileDownloadDone: () => import('@mui/icons-material/FileDownloadDone'),
  FileDownloadOff: () => import('@mui/icons-material/FileDownloadOff'),
  FileOpen: () => import('@mui/icons-material/FileOpen'),
  FilePresent: () => import('@mui/icons-material/FilePresent'),
  FileUpload: () => import('@mui/icons-material/FileUpload'),
  FileUploadOff: () => import('@mui/icons-material/FileUploadOff'),
  Filter: () => import('@mui/icons-material/Filter'),
  Filter1: () => import('@mui/icons-material/Filter1'),
  Filter2: () => import('@mui/icons-material/Filter2'),
  Filter3: () => import('@mui/icons-material/Filter3'),
  Filter4: () => import('@mui/icons-material/Filter4'),
  Filter5: () => import('@mui/icons-material/Filter5'),
  Filter6: () => import('@mui/icons-material/Filter6'),
  Filter7: () => import('@mui/icons-material/Filter7'),
  Filter8: () => import('@mui/icons-material/Filter8'),
  Filter9: () => import('@mui/icons-material/Filter9'),
  Filter9Plus: () => import('@mui/icons-material/Filter9Plus'),
  FilterAlt: () => import('@mui/icons-material/FilterAlt'),
  FilterAltOff: () => import('@mui/icons-material/FilterAltOff'),
  FilterBAndW: () => import('@mui/icons-material/FilterBAndW'),
  FilterCenterFocus: () => import('@mui/icons-material/FilterCenterFocus'),
  FilterDrama: () => import('@mui/icons-material/FilterDrama'),
  FilterFrames: () => import('@mui/icons-material/FilterFrames'),
  FilterHdr: () => import('@mui/icons-material/FilterHdr'),
  FilterList: () => import('@mui/icons-material/FilterList'),
  FilterListAlt: () => import('@mui/icons-material/FilterListAlt'),
  FilterListOff: () => import('@mui/icons-material/FilterListOff'),
  FilterNone: () => import('@mui/icons-material/FilterNone'),
  FilterTiltShift: () => import('@mui/icons-material/FilterTiltShift'),
  FilterVintage: () => import('@mui/icons-material/FilterVintage'),
  FindInPage: () => import('@mui/icons-material/FindInPage'),
  FindReplace: () => import('@mui/icons-material/FindReplace'),
  Fingerprint: () => import('@mui/icons-material/Fingerprint'),
  FireExtinguisher: () => import('@mui/icons-material/FireExtinguisher'),
  FireHydrantAlt: () => import('@mui/icons-material/FireHydrantAlt'),
  FireTruck: () => import('@mui/icons-material/FireTruck'),
  Fireplace: () => import('@mui/icons-material/Fireplace'),
  FirstPage: () => import('@mui/icons-material/FirstPage'),
  FitScreen: () => import('@mui/icons-material/FitScreen'),
  Fitbit: () => import('@mui/icons-material/Fitbit'),
  FitnessCenter: () => import('@mui/icons-material/FitnessCenter'),
  FiveG: () => import('@mui/icons-material/FiveG'),
  FiveK: () => import('@mui/icons-material/FiveK'),
  FiveKPlus: () => import('@mui/icons-material/FiveKPlus'),
  FiveMp: () => import('@mui/icons-material/FiveMp'),
  FivteenMp: () => import('@mui/icons-material/FivteenMp'),
  FlagCircle: () => import('@mui/icons-material/FlagCircle'),
  Flaky: () => import('@mui/icons-material/Flaky'),
  Flare: () => import('@mui/icons-material/Flare'),
  FlashAuto: () => import('@mui/icons-material/FlashAuto'),
  FlashOff: () => import('@mui/icons-material/FlashOff'),
  FlashOn: () => import('@mui/icons-material/FlashOn'),
  FlashlightOff: () => import('@mui/icons-material/FlashlightOff'),
  FlashlightOn: () => import('@mui/icons-material/FlashlightOn'),
  Flatware: () => import('@mui/icons-material/Flatware'),
  Flight: () => import('@mui/icons-material/Flight'),
  FlightClass: () => import('@mui/icons-material/FlightClass'),
  FlightLand: () => import('@mui/icons-material/FlightLand'),
  FlightTakeoff: () => import('@mui/icons-material/FlightTakeoff'),
  Flip: () => import('@mui/icons-material/Flip'),
  FlipCameraAndroid: () => import('@mui/icons-material/FlipCameraAndroid'),
  FlipCameraIos: () => import('@mui/icons-material/FlipCameraIos'),
  FlipToBack: () => import('@mui/icons-material/FlipToBack'),
  FlipToFront: () => import('@mui/icons-material/FlipToFront'),
  Flood: () => import('@mui/icons-material/Flood'),
  Fluorescent: () => import('@mui/icons-material/Fluorescent'),
  FlutterDash: () => import('@mui/icons-material/FlutterDash'),
  FmdBad: () => import('@mui/icons-material/FmdBad'),
  FmdGood: () => import('@mui/icons-material/FmdGood'),
  Foggy: () => import('@mui/icons-material/Foggy'),
  Folder: () => import('@mui/icons-material/Folder'),
  FolderCopy: () => import('@mui/icons-material/FolderCopy'),
  FolderDelete: () => import('@mui/icons-material/FolderDelete'),
  FolderOff: () => import('@mui/icons-material/FolderOff'),
  FolderOpen: () => import('@mui/icons-material/FolderOpen'),
  FolderShared: () => import('@mui/icons-material/FolderShared'),
  FolderSpecial: () => import('@mui/icons-material/FolderSpecial'),
  FolderZip: () => import('@mui/icons-material/FolderZip'),
  FollowTheSigns: () => import('@mui/icons-material/FollowTheSigns'),
  FontDownload: () => import('@mui/icons-material/FontDownload'),
  FontDownloadOff: () => import('@mui/icons-material/FontDownloadOff'),
  FoodBank: () => import('@mui/icons-material/FoodBank'),
  ForkLeft: () => import('@mui/icons-material/ForkLeft'),
  ForkRight: () => import('@mui/icons-material/ForkRight'),
  Forklift: () => import('@mui/icons-material/Forklift'),
  FormatAlignCenter: () => import('@mui/icons-material/FormatAlignCenter'),
  FormatAlignJustify: () => import('@mui/icons-material/FormatAlignJustify'),
  FormatAlignLeft: () => import('@mui/icons-material/FormatAlignLeft'),
  FormatAlignRight: () => import('@mui/icons-material/FormatAlignRight'),
  FormatBold: () => import('@mui/icons-material/FormatBold'),
  FormatClear: () => import('@mui/icons-material/FormatClear'),
  FormatColorFill: () => import('@mui/icons-material/FormatColorFill'),
  FormatColorReset: () => import('@mui/icons-material/FormatColorReset'),
  FormatColorText: () => import('@mui/icons-material/FormatColorText'),
  FormatIndentDecrease: () => import('@mui/icons-material/FormatIndentDecrease'),
  FormatIndentIncrease: () => import('@mui/icons-material/FormatIndentIncrease'),
  FormatItalic: () => import('@mui/icons-material/FormatItalic'),
  FormatLineSpacing: () => import('@mui/icons-material/FormatLineSpacing'),
  FormatListBulleted: () => import('@mui/icons-material/FormatListBulleted'),
  FormatListBulletedAdd: () => import('@mui/icons-material/FormatListBulletedAdd'),
  FormatListNumbered: () => import('@mui/icons-material/FormatListNumbered'),
  FormatListNumberedRtl: () => import('@mui/icons-material/FormatListNumberedRtl'),
  FormatOverline: () => import('@mui/icons-material/FormatOverline'),
  FormatPaint: () => import('@mui/icons-material/FormatPaint'),
  FormatQuote: () => import('@mui/icons-material/FormatQuote'),
  FormatShapes: () => import('@mui/icons-material/FormatShapes'),
  FormatSize: () => import('@mui/icons-material/FormatSize'),
  FormatStrikethrough: () => import('@mui/icons-material/FormatStrikethrough'),
  FormatTextdirectionLToR: () => import('@mui/icons-material/FormatTextdirectionLToR'),
  FormatTextdirectionRToL: () => import('@mui/icons-material/FormatTextdirectionRToL'),
  FormatUnderlined: () => import('@mui/icons-material/FormatUnderlined'),
  Fort: () => import('@mui/icons-material/Fort'),
  Forum: () => import('@mui/icons-material/Forum'),
  Forward: () => import('@mui/icons-material/Forward'),
  Forward10: () => import('@mui/icons-material/Forward10'),
  Forward30: () => import('@mui/icons-material/Forward30'),
  Forward5: () => import('@mui/icons-material/Forward5'),
  ForwardToInbox: () => import('@mui/icons-material/ForwardToInbox'),
  Foundation: () => import('@mui/icons-material/Foundation'),
  FourGMobiledata: () => import('@mui/icons-material/FourGMobiledata'),
  FourGPlusMobiledata: () => import('@mui/icons-material/FourGPlusMobiledata'),
  FourK: () => import('@mui/icons-material/FourK'),
  FourKPlus: () => import('@mui/icons-material/FourKPlus'),
  FourMp: () => import('@mui/icons-material/FourMp'),
  FourteenMp: () => import('@mui/icons-material/FourteenMp'),
  FreeBreakfast: () => import('@mui/icons-material/FreeBreakfast'),
  FreeCancellation: () => import('@mui/icons-material/FreeCancellation'),
  FrontHand: () => import('@mui/icons-material/FrontHand'),
  FrontLoader: () => import('@mui/icons-material/FrontLoader'),
  Fullscreen: () => import('@mui/icons-material/Fullscreen'),
  FullscreenExit: () => import('@mui/icons-material/FullscreenExit'),
  Functions: () => import('@mui/icons-material/Functions'),
  GMobiledata: () => import('@mui/icons-material/GMobiledata'),
  GTranslate: () => import('@mui/icons-material/GTranslate'),
  Gamepad: () => import('@mui/icons-material/Gamepad'),
  Games: () => import('@mui/icons-material/Games'),
  Garage: () => import('@mui/icons-material/Garage'),
  GasMeter: () => import('@mui/icons-material/GasMeter'),
  Gavel: () => import('@mui/icons-material/Gavel'),
  GeneratingTokens: () => import('@mui/icons-material/GeneratingTokens'),
  Gesture: () => import('@mui/icons-material/Gesture'),
  GetApp: () => import('@mui/icons-material/GetApp'),
  Gif: () => import('@mui/icons-material/Gif'),
  GifBox: () => import('@mui/icons-material/GifBox'),
  Girl: () => import('@mui/icons-material/Girl'),
  GitHub: () => import('@mui/icons-material/GitHub'),
  Gite: () => import('@mui/icons-material/Gite'),
  GolfCourse: () => import('@mui/icons-material/GolfCourse'),
  Google: () => import('@mui/icons-material/Google'),
  GppBad: () => import('@mui/icons-material/GppBad'),
  GppGood: () => import('@mui/icons-material/GppGood'),
  GppMaybe: () => import('@mui/icons-material/GppMaybe'),
  GpsFixed: () => import('@mui/icons-material/GpsFixed'),
  GpsNotFixed: () => import('@mui/icons-material/GpsNotFixed'),
  GpsOff: () => import('@mui/icons-material/GpsOff'),
  Grade: () => import('@mui/icons-material/Grade'),
  Gradient: () => import('@mui/icons-material/Gradient'),
  Grading: () => import('@mui/icons-material/Grading'),
  Grain: () => import('@mui/icons-material/Grain'),
  GraphicEq: () => import('@mui/icons-material/GraphicEq'),
  Grass: () => import('@mui/icons-material/Grass'),
  Grid3x3: () => import('@mui/icons-material/Grid3x3'),
  Grid4x4: () => import('@mui/icons-material/Grid4x4'),
  GridGoldenratio: () => import('@mui/icons-material/GridGoldenratio'),
  GridOff: () => import('@mui/icons-material/GridOff'),
  GridOn: () => import('@mui/icons-material/GridOn'),
  GridView: () => import('@mui/icons-material/GridView'),
  GroupAdd: () => import('@mui/icons-material/GroupAdd'),
  GroupOff: () => import('@mui/icons-material/GroupOff'),
  GroupRemove: () => import('@mui/icons-material/GroupRemove'),
  GroupWork: () => import('@mui/icons-material/GroupWork'),
  Groups: () => import('@mui/icons-material/Groups'),
  Groups2: () => import('@mui/icons-material/Groups2'),
  Groups3: () => import('@mui/icons-material/Groups3'),
  HMobiledata: () => import('@mui/icons-material/HMobiledata'),
  HPlusMobiledata: () => import('@mui/icons-material/HPlusMobiledata'),
  Hail: () => import('@mui/icons-material/Hail'),
  Handshake: () => import('@mui/icons-material/Handshake'),
  Handyman: () => import('@mui/icons-material/Handyman'),
  Hardware: () => import('@mui/icons-material/Hardware'),
  Hd: () => import('@mui/icons-material/Hd'),
  HdrAuto: () => import('@mui/icons-material/HdrAuto'),
  HdrAutoSelect: () => import('@mui/icons-material/HdrAutoSelect'),
  HdrEnhancedSelect: () => import('@mui/icons-material/HdrEnhancedSelect'),
  HdrOff: () => import('@mui/icons-material/HdrOff'),
  HdrOffSelect: () => import('@mui/icons-material/HdrOffSelect'),
  HdrOn: () => import('@mui/icons-material/HdrOn'),
  HdrOnSelect: () => import('@mui/icons-material/HdrOnSelect'),
  HdrPlus: () => import('@mui/icons-material/HdrPlus'),
  HdrStrong: () => import('@mui/icons-material/HdrStrong'),
  HdrWeak: () => import('@mui/icons-material/HdrWeak'),
  Headphones: () => import('@mui/icons-material/Headphones'),
  HeadphonesBattery: () => import('@mui/icons-material/HeadphonesBattery'),
  Headset: () => import('@mui/icons-material/Headset'),
  HeadsetMic: () => import('@mui/icons-material/HeadsetMic'),
  HeadsetOff: () => import('@mui/icons-material/HeadsetOff'),
  Healing: () => import('@mui/icons-material/Healing'),
  Hearing: () => import('@mui/icons-material/Hearing'),
  HearingDisabled: () => import('@mui/icons-material/HearingDisabled'),
  HeartBroken: () => import('@mui/icons-material/HeartBroken'),
  HeatPump: () => import('@mui/icons-material/HeatPump'),
  Height: () => import('@mui/icons-material/Height'),
  HelpCenter: () => import('@mui/icons-material/HelpCenter'),
  Hevc: () => import('@mui/icons-material/Hevc'),
  Hexagon: () => import('@mui/icons-material/Hexagon'),
  HideImage: () => import('@mui/icons-material/HideImage'),
  HideSource: () => import('@mui/icons-material/HideSource'),
  HighQuality: () => import('@mui/icons-material/HighQuality'),
  Highlight: () => import('@mui/icons-material/Highlight'),
  HighlightAlt: () => import('@mui/icons-material/HighlightAlt'),
  HighlightOff: () => import('@mui/icons-material/HighlightOff'),
  History: () => import('@mui/icons-material/History'),
  HistoryEdu: () => import('@mui/icons-material/HistoryEdu'),
  HistoryToggleOff: () => import('@mui/icons-material/HistoryToggleOff'),
  Hive: () => import('@mui/icons-material/Hive'),
  Hls: () => import('@mui/icons-material/Hls'),
  HlsOff: () => import('@mui/icons-material/HlsOff'),
  HolidayVillage: () => import('@mui/icons-material/HolidayVillage'),
  HomeFilled: () => import('@mui/icons-material/HomeFilled'),
  HomeMax: () => import('@mui/icons-material/HomeMax'),
  HomeMini: () => import('@mui/icons-material/HomeMini'),
  HomeRepairService: () => import('@mui/icons-material/HomeRepairService'),
  HomeWork: () => import('@mui/icons-material/HomeWork'),
  HorizontalRule: () => import('@mui/icons-material/HorizontalRule'),
  HorizontalSplit: () => import('@mui/icons-material/HorizontalSplit'),
  HotTub: () => import('@mui/icons-material/HotTub'),
  Hotel: () => import('@mui/icons-material/Hotel'),
  HotelClass: () => import('@mui/icons-material/HotelClass'),
  HourglassBottom: () => import('@mui/icons-material/HourglassBottom'),
  HourglassDisabled: () => import('@mui/icons-material/HourglassDisabled'),
  HourglassEmpty: () => import('@mui/icons-material/HourglassEmpty'),
  HourglassFull: () => import('@mui/icons-material/HourglassFull'),
  HourglassTop: () => import('@mui/icons-material/HourglassTop'),
  House: () => import('@mui/icons-material/House'),
  HouseSiding: () => import('@mui/icons-material/HouseSiding'),
  Houseboat: () => import('@mui/icons-material/Houseboat'),
  HowToReg: () => import('@mui/icons-material/HowToReg'),
  HowToVote: () => import('@mui/icons-material/HowToVote'),
  Html: () => import('@mui/icons-material/Html'),
  Http: () => import('@mui/icons-material/Http'),
  Https: () => import('@mui/icons-material/Https'),
  Hub: () => import('@mui/icons-material/Hub'),
  Hvac: () => import('@mui/icons-material/Hvac'),
  IceSkating: () => import('@mui/icons-material/IceSkating'),
  Icecream: () => import('@mui/icons-material/Icecream'),
  ImageAspectRatio: () => import('@mui/icons-material/ImageAspectRatio'),
  ImageNotSupported: () => import('@mui/icons-material/ImageNotSupported'),
  ImageSearch: () => import('@mui/icons-material/ImageSearch'),
  ImagesearchRoller: () => import('@mui/icons-material/ImagesearchRoller'),
  ImportContacts: () => import('@mui/icons-material/ImportContacts'),
  ImportExport: () => import('@mui/icons-material/ImportExport'),
  ImportantDevices: () => import('@mui/icons-material/ImportantDevices'),
  IncompleteCircle: () => import('@mui/icons-material/IncompleteCircle'),
  IndeterminateCheckBox: () => import('@mui/icons-material/IndeterminateCheckBox'),
  Input: () => import('@mui/icons-material/Input'),
  InsertChart: () => import('@mui/icons-material/InsertChart'),
  InsertComment: () => import('@mui/icons-material/InsertComment'),
  InsertDriveFile: () => import('@mui/icons-material/InsertDriveFile'),
  InsertEmoticon: () => import('@mui/icons-material/InsertEmoticon'),
  InsertInvitation: () => import('@mui/icons-material/InsertInvitation'),
  InsertLink: () => import('@mui/icons-material/InsertLink'),
  InsertPageBreak: () => import('@mui/icons-material/InsertPageBreak'),
  InsertPhoto: () => import('@mui/icons-material/InsertPhoto'),
  Insights: () => import('@mui/icons-material/Insights'),
  Instagram: () => import('@mui/icons-material/Instagram'),
  InstallDesktop: () => import('@mui/icons-material/InstallDesktop'),
  InstallMobile: () => import('@mui/icons-material/InstallMobile'),
  IntegrationInstructions: () => import('@mui/icons-material/IntegrationInstructions'),
  Interests: () => import('@mui/icons-material/Interests'),
  InterpreterMode: () => import('@mui/icons-material/InterpreterMode'),
  Inventory: () => import('@mui/icons-material/Inventory'),
  Inventory2: () => import('@mui/icons-material/Inventory2'),
  InvertColors: () => import('@mui/icons-material/InvertColors'),
  InvertColorsOff: () => import('@mui/icons-material/InvertColorsOff'),
  IosShare: () => import('@mui/icons-material/IosShare'),
  Iron: () => import('@mui/icons-material/Iron'),
  Iso: () => import('@mui/icons-material/Iso'),
  Javascript: () => import('@mui/icons-material/Javascript'),
  JoinFull: () => import('@mui/icons-material/JoinFull'),
  JoinInner: () => import('@mui/icons-material/JoinInner'),
  JoinLeft: () => import('@mui/icons-material/JoinLeft'),
  JoinRight: () => import('@mui/icons-material/JoinRight'),
  Kayaking: () => import('@mui/icons-material/Kayaking'),
  KebabDining: () => import('@mui/icons-material/KebabDining'),
  Key: () => import('@mui/icons-material/Key'),
  KeyOff: () => import('@mui/icons-material/KeyOff'),
  Keyboard: () => import('@mui/icons-material/Keyboard'),
  KeyboardAlt: () => import('@mui/icons-material/KeyboardAlt'),
  KeyboardArrowDown: () => import('@mui/icons-material/KeyboardArrowDown'),
  KeyboardArrowLeft: () => import('@mui/icons-material/KeyboardArrowLeft'),
  KeyboardArrowRight: () => import('@mui/icons-material/KeyboardArrowRight'),
  KeyboardArrowUp: () => import('@mui/icons-material/KeyboardArrowUp'),
  KeyboardBackspace: () => import('@mui/icons-material/KeyboardBackspace'),
  KeyboardCapslock: () => import('@mui/icons-material/KeyboardCapslock'),
  KeyboardCommandKey: () => import('@mui/icons-material/KeyboardCommandKey'),
  KeyboardControlKey: () => import('@mui/icons-material/KeyboardControlKey'),
  KeyboardDoubleArrowDown: () => import('@mui/icons-material/KeyboardDoubleArrowDown'),
  KeyboardDoubleArrowLeft: () => import('@mui/icons-material/KeyboardDoubleArrowLeft'),
  KeyboardDoubleArrowRight: () => import('@mui/icons-material/KeyboardDoubleArrowRight'),
  KeyboardDoubleArrowUp: () => import('@mui/icons-material/KeyboardDoubleArrowUp'),
  KeyboardHide: () => import('@mui/icons-material/KeyboardHide'),
  KeyboardOptionKey: () => import('@mui/icons-material/KeyboardOptionKey'),
  KeyboardReturn: () => import('@mui/icons-material/KeyboardReturn'),
  KeyboardTab: () => import('@mui/icons-material/KeyboardTab'),
  KeyboardVoice: () => import('@mui/icons-material/KeyboardVoice'),
  KingBed: () => import('@mui/icons-material/KingBed'),
  Kitchen: () => import('@mui/icons-material/Kitchen'),
  Kitesurfing: () => import('@mui/icons-material/Kitesurfing'),
  Label: () => import('@mui/icons-material/Label'),
  LabelImportant: () => import('@mui/icons-material/LabelImportant'),
  LabelOff: () => import('@mui/icons-material/LabelOff'),
  Lan: () => import('@mui/icons-material/Lan'),
  Landscape: () => import('@mui/icons-material/Landscape'),
  Landslide: () => import('@mui/icons-material/Landslide'),
  Language: () => import('@mui/icons-material/Language'),
  Laptop: () => import('@mui/icons-material/Laptop'),
  LaptopChromebook: () => import('@mui/icons-material/LaptopChromebook'),
  LaptopMac: () => import('@mui/icons-material/LaptopMac'),
  LaptopWindows: () => import('@mui/icons-material/LaptopWindows'),
  LastPage: () => import('@mui/icons-material/LastPage'),
  Launch: () => import('@mui/icons-material/Launch'),
  Layers: () => import('@mui/icons-material/Layers'),
  LayersClear: () => import('@mui/icons-material/LayersClear'),
  Leaderboard: () => import('@mui/icons-material/Leaderboard'),
  LeakAdd: () => import('@mui/icons-material/LeakAdd'),
  LeakRemove: () => import('@mui/icons-material/LeakRemove'),
  LegendToggle: () => import('@mui/icons-material/LegendToggle'),
  Lens: () => import('@mui/icons-material/Lens'),
  LensBlur: () => import('@mui/icons-material/LensBlur'),
  LibraryAdd: () => import('@mui/icons-material/LibraryAdd'),
  LibraryAddCheck: () => import('@mui/icons-material/LibraryAddCheck'),
  LibraryBooks: () => import('@mui/icons-material/LibraryBooks'),
  LibraryMusic: () => import('@mui/icons-material/LibraryMusic'),
  Light: () => import('@mui/icons-material/Light'),
  LightMode: () => import('@mui/icons-material/LightMode'),
  Lightbulb: () => import('@mui/icons-material/Lightbulb'),
  LightbulbCircle: () => import('@mui/icons-material/LightbulbCircle'),
  LineAxis: () => import('@mui/icons-material/LineAxis'),
  LineStyle: () => import('@mui/icons-material/LineStyle'),
  LineWeight: () => import('@mui/icons-material/LineWeight'),
  LinearScale: () => import('@mui/icons-material/LinearScale'),
  LinkOff: () => import('@mui/icons-material/LinkOff'),
  LinkedCamera: () => import('@mui/icons-material/LinkedCamera'),
  LinkedIn: () => import('@mui/icons-material/LinkedIn'),
  Liquor: () => import('@mui/icons-material/Liquor'),
  List: () => import('@mui/icons-material/List'),
  ListAlt: () => import('@mui/icons-material/ListAlt'),
  LiveHelp: () => import('@mui/icons-material/LiveHelp'),
  LiveTv: () => import('@mui/icons-material/LiveTv'),
  Living: () => import('@mui/icons-material/Living'),
  LocalActivity: () => import('@mui/icons-material/LocalActivity'),
  LocalAirport: () => import('@mui/icons-material/LocalAirport'),
  LocalAtm: () => import('@mui/icons-material/LocalAtm'),
  LocalBar: () => import('@mui/icons-material/LocalBar'),
  LocalCarWash: () => import('@mui/icons-material/LocalCarWash'),
  LocalConvenienceStore: () => import('@mui/icons-material/LocalConvenienceStore'),
  LocalDining: () => import('@mui/icons-material/LocalDining'),
  LocalDrink: () => import('@mui/icons-material/LocalDrink'),
  LocalFireDepartment: () => import('@mui/icons-material/LocalFireDepartment'),
  LocalFlorist: () => import('@mui/icons-material/LocalFlorist'),
  LocalGasStation: () => import('@mui/icons-material/LocalGasStation'),
  LocalGroceryStore: () => import('@mui/icons-material/LocalGroceryStore'),
  LocalHotel: () => import('@mui/icons-material/LocalHotel'),
  LocalLaundryService: () => import('@mui/icons-material/LocalLaundryService'),
  LocalLibrary: () => import('@mui/icons-material/LocalLibrary'),
  LocalMall: () => import('@mui/icons-material/LocalMall'),
  LocalMovies: () => import('@mui/icons-material/LocalMovies'),
  LocalParking: () => import('@mui/icons-material/LocalParking'),
  LocalPharmacy: () => import('@mui/icons-material/LocalPharmacy'),
  LocalPhone: () => import('@mui/icons-material/LocalPhone'),
  LocalPizza: () => import('@mui/icons-material/LocalPizza'),
  LocalPlay: () => import('@mui/icons-material/LocalPlay'),
  LocalPolice: () => import('@mui/icons-material/LocalPolice'),
  LocalPostOffice: () => import('@mui/icons-material/LocalPostOffice'),
  LocalPrintshop: () => import('@mui/icons-material/LocalPrintshop'),
  LocalSee: () => import('@mui/icons-material/LocalSee'),
  LocalShipping: () => import('@mui/icons-material/LocalShipping'),
  LocalTaxi: () => import('@mui/icons-material/LocalTaxi'),
  LocationCity: () => import('@mui/icons-material/LocationCity'),
  LocationDisabled: () => import('@mui/icons-material/LocationDisabled'),
  LocationOff: () => import('@mui/icons-material/LocationOff'),
  LocationPin: () => import('@mui/icons-material/LocationPin'),
  LocationSearching: () => import('@mui/icons-material/LocationSearching'),
  LockClock: () => import('@mui/icons-material/LockClock'),
  LockPerson: () => import('@mui/icons-material/LockPerson'),
  LockReset: () => import('@mui/icons-material/LockReset'),
  Login: () => import('@mui/icons-material/Login'),
  LogoDev: () => import('@mui/icons-material/LogoDev'),
  Logout: () => import('@mui/icons-material/Logout'),
  Looks: () => import('@mui/icons-material/Looks'),
  Looks3: () => import('@mui/icons-material/Looks3'),
  Looks4: () => import('@mui/icons-material/Looks4'),
  Looks5: () => import('@mui/icons-material/Looks5'),
  Looks6: () => import('@mui/icons-material/Looks6'),
  LooksOne: () => import('@mui/icons-material/LooksOne'),
  LooksTwo: () => import('@mui/icons-material/LooksTwo'),
  Loop: () => import('@mui/icons-material/Loop'),
  Loupe: () => import('@mui/icons-material/Loupe'),
  LowPriority: () => import('@mui/icons-material/LowPriority'),
  Loyalty: () => import('@mui/icons-material/Loyalty'),
  LteMobiledata: () => import('@mui/icons-material/LteMobiledata'),
  LtePlusMobiledata: () => import('@mui/icons-material/LtePlusMobiledata'),
  Luggage: () => import('@mui/icons-material/Luggage'),
  LunchDining: () => import('@mui/icons-material/LunchDining'),
  Lyrics: () => import('@mui/icons-material/Lyrics'),
  MacroOff: () => import('@mui/icons-material/MacroOff'),
  MailLock: () => import('@mui/icons-material/MailLock'),
  Male: () => import('@mui/icons-material/Male'),
  Man: () => import('@mui/icons-material/Man'),
  Man2: () => import('@mui/icons-material/Man2'),
  Man3: () => import('@mui/icons-material/Man3'),
  Man4: () => import('@mui/icons-material/Man4'),
  ManageAccounts: () => import('@mui/icons-material/ManageAccounts'),
  ManageHistory: () => import('@mui/icons-material/ManageHistory'),
  ManageSearch: () => import('@mui/icons-material/ManageSearch'),
  MapsHomeWork: () => import('@mui/icons-material/MapsHomeWork'),
  MapsUgc: () => import('@mui/icons-material/MapsUgc'),
  Margin: () => import('@mui/icons-material/Margin'),
  MarkAsUnread: () => import('@mui/icons-material/MarkAsUnread'),
  MarkChatRead: () => import('@mui/icons-material/MarkChatRead'),
  MarkChatUnread: () => import('@mui/icons-material/MarkChatUnread'),
  MarkEmailUnread: () => import('@mui/icons-material/MarkEmailUnread'),
  MarkUnreadChatAlt: () => import('@mui/icons-material/MarkUnreadChatAlt'),
  Markunread: () => import('@mui/icons-material/Markunread'),
  MarkunreadMailbox: () => import('@mui/icons-material/MarkunreadMailbox'),
  Masks: () => import('@mui/icons-material/Masks'),
  Maximize: () => import('@mui/icons-material/Maximize'),
  MediaBluetoothOff: () => import('@mui/icons-material/MediaBluetoothOff'),
  MediaBluetoothOn: () => import('@mui/icons-material/MediaBluetoothOn'),
  Mediation: () => import('@mui/icons-material/Mediation'),
  MedicalInformation: () => import('@mui/icons-material/MedicalInformation'),
  Medication: () => import('@mui/icons-material/Medication'),
  MedicationLiquid: () => import('@mui/icons-material/MedicationLiquid'),
  MeetingRoom: () => import('@mui/icons-material/MeetingRoom'),
  Memory: () => import('@mui/icons-material/Memory'),
  Menu: () => import('@mui/icons-material/Menu'),
  MenuOpen: () => import('@mui/icons-material/MenuOpen'),
  Merge: () => import('@mui/icons-material/Merge'),
  MergeType: () => import('@mui/icons-material/MergeType'),
  Message: () => import('@mui/icons-material/Message'),
  Mic: () => import('@mui/icons-material/Mic'),
  MicExternalOff: () => import('@mui/icons-material/MicExternalOff'),
  MicExternalOn: () => import('@mui/icons-material/MicExternalOn'),
  MicNone: () => import('@mui/icons-material/MicNone'),
  MicOff: () => import('@mui/icons-material/MicOff'),
  Microsoft: () => import('@mui/icons-material/Microsoft'),
  Microwave: () => import('@mui/icons-material/Microwave'),
  Minimize: () => import('@mui/icons-material/Minimize'),
  MinorCrash: () => import('@mui/icons-material/MinorCrash'),
  MiscellaneousServices: () => import('@mui/icons-material/MiscellaneousServices'),
  MissedVideoCall: () => import('@mui/icons-material/MissedVideoCall'),
  Mms: () => import('@mui/icons-material/Mms'),
  MobileFriendly: () => import('@mui/icons-material/MobileFriendly'),
  MobileOff: () => import('@mui/icons-material/MobileOff'),
  MobileScreenShare: () => import('@mui/icons-material/MobileScreenShare'),
  MobiledataOff: () => import('@mui/icons-material/MobiledataOff'),
  Mode: () => import('@mui/icons-material/Mode'),
  ModeComment: () => import('@mui/icons-material/ModeComment'),
  ModeEdit: () => import('@mui/icons-material/ModeEdit'),
  ModeFanOff: () => import('@mui/icons-material/ModeFanOff'),
  ModeNight: () => import('@mui/icons-material/ModeNight'),
  ModeOfTravel: () => import('@mui/icons-material/ModeOfTravel'),
  ModeStandby: () => import('@mui/icons-material/ModeStandby'),
  ModelTraining: () => import('@mui/icons-material/ModelTraining'),
  MonetizationOn: () => import('@mui/icons-material/MonetizationOn'),
  Money: () => import('@mui/icons-material/Money'),
  MoneyOff: () => import('@mui/icons-material/MoneyOff'),
  MoneyOffCsred: () => import('@mui/icons-material/MoneyOffCsred'),
  Monitor: () => import('@mui/icons-material/Monitor'),
  MonitorHeart: () => import('@mui/icons-material/MonitorHeart'),
  MonitorWeight: () => import('@mui/icons-material/MonitorWeight'),
  MonochromePhotos: () => import('@mui/icons-material/MonochromePhotos'),
  Mood: () => import('@mui/icons-material/Mood'),
  MoodBad: () => import('@mui/icons-material/MoodBad'),
  Moped: () => import('@mui/icons-material/Moped'),
  More: () => import('@mui/icons-material/More'),
  MoreHoriz: () => import('@mui/icons-material/MoreHoriz'),
  MoreTime: () => import('@mui/icons-material/MoreTime'),
  MoreVert: () => import('@mui/icons-material/MoreVert'),
  Mosque: () => import('@mui/icons-material/Mosque'),
  MotionPhotosAuto: () => import('@mui/icons-material/MotionPhotosAuto'),
  MotionPhotosOff: () => import('@mui/icons-material/MotionPhotosOff'),
  Mouse: () => import('@mui/icons-material/Mouse'),
  MoveDown: () => import('@mui/icons-material/MoveDown'),
  MoveToInbox: () => import('@mui/icons-material/MoveToInbox'),
  MoveUp: () => import('@mui/icons-material/MoveUp'),
  Movie: () => import('@mui/icons-material/Movie'),
  MovieCreation: () => import('@mui/icons-material/MovieCreation'),
  MovieEdit: () => import('@mui/icons-material/MovieEdit'),
  MovieFilter: () => import('@mui/icons-material/MovieFilter'),
  Moving: () => import('@mui/icons-material/Moving'),
  Mp: () => import('@mui/icons-material/Mp'),
  MultilineChart: () => import('@mui/icons-material/MultilineChart'),
  MultipleStop: () => import('@mui/icons-material/MultipleStop'),
  Museum: () => import('@mui/icons-material/Museum'),
  MusicNote: () => import('@mui/icons-material/MusicNote'),
  MusicOff: () => import('@mui/icons-material/MusicOff'),
  MusicVideo: () => import('@mui/icons-material/MusicVideo'),
  Nat: () => import('@mui/icons-material/Nat'),
  Nature: () => import('@mui/icons-material/Nature'),
  NaturePeople: () => import('@mui/icons-material/NaturePeople'),
  NavigateBefore: () => import('@mui/icons-material/NavigateBefore'),
  NavigateNext: () => import('@mui/icons-material/NavigateNext'),
  NearMe: () => import('@mui/icons-material/NearMe'),
  NearMeDisabled: () => import('@mui/icons-material/NearMeDisabled'),
  NearbyError: () => import('@mui/icons-material/NearbyError'),
  NearbyOff: () => import('@mui/icons-material/NearbyOff'),
  NestCamWiredStand: () => import('@mui/icons-material/NestCamWiredStand'),
  NetworkCell: () => import('@mui/icons-material/NetworkCell'),
  NetworkCheck: () => import('@mui/icons-material/NetworkCheck'),
  NetworkLocked: () => import('@mui/icons-material/NetworkLocked'),
  NetworkPing: () => import('@mui/icons-material/NetworkPing'),
  NetworkWifi: () => import('@mui/icons-material/NetworkWifi'),
  NetworkWifi1Bar: () => import('@mui/icons-material/NetworkWifi1Bar'),
  NetworkWifi2Bar: () => import('@mui/icons-material/NetworkWifi2Bar'),
  NetworkWifi3Bar: () => import('@mui/icons-material/NetworkWifi3Bar'),
  NewLabel: () => import('@mui/icons-material/NewLabel'),
  NewReleases: () => import('@mui/icons-material/NewReleases'),
  Newspaper: () => import('@mui/icons-material/Newspaper'),
  NextPlan: () => import('@mui/icons-material/NextPlan'),
  NextWeek: () => import('@mui/icons-material/NextWeek'),
  Nfc: () => import('@mui/icons-material/Nfc'),
  NightShelter: () => import('@mui/icons-material/NightShelter'),
  Nightlife: () => import('@mui/icons-material/Nightlife'),
  Nightlight: () => import('@mui/icons-material/Nightlight'),
  NightlightRound: () => import('@mui/icons-material/NightlightRound'),
  NightsStay: () => import('@mui/icons-material/NightsStay'),
  NineK: () => import('@mui/icons-material/NineK'),
  NineKPlus: () => import('@mui/icons-material/NineKPlus'),
  NineMp: () => import('@mui/icons-material/NineMp'),
  NineteenMp: () => import('@mui/icons-material/NineteenMp'),
  NoAccounts: () => import('@mui/icons-material/NoAccounts'),
  NoAdultContent: () => import('@mui/icons-material/NoAdultContent'),
  NoBackpack: () => import('@mui/icons-material/NoBackpack'),
  NoCell: () => import('@mui/icons-material/NoCell'),
  NoCrash: () => import('@mui/icons-material/NoCrash'),
  NoDrinks: () => import('@mui/icons-material/NoDrinks'),
  NoEncryption: () => import('@mui/icons-material/NoEncryption'),
  NoEncryptionGmailerrorred: () => import('@mui/icons-material/NoEncryptionGmailerrorred'),
  NoFlash: () => import('@mui/icons-material/NoFlash'),
  NoFood: () => import('@mui/icons-material/NoFood'),
  NoLuggage: () => import('@mui/icons-material/NoLuggage'),
  NoMeals: () => import('@mui/icons-material/NoMeals'),
  NoMealsOuline: () => import('@mui/icons-material/NoMealsOuline'),
  NoMeetingRoom: () => import('@mui/icons-material/NoMeetingRoom'),
  NoPhotography: () => import('@mui/icons-material/NoPhotography'),
  NoSim: () => import('@mui/icons-material/NoSim'),
  NoStroller: () => import('@mui/icons-material/NoStroller'),
  NoTransfer: () => import('@mui/icons-material/NoTransfer'),
  NoiseAware: () => import('@mui/icons-material/NoiseAware'),
  NoiseControlOff: () => import('@mui/icons-material/NoiseControlOff'),
  NordicWalking: () => import('@mui/icons-material/NordicWalking'),
  North: () => import('@mui/icons-material/North'),
  NorthEast: () => import('@mui/icons-material/NorthEast'),
  NorthWest: () => import('@mui/icons-material/NorthWest'),
  NotAccessible: () => import('@mui/icons-material/NotAccessible'),
  NotInterested: () => import('@mui/icons-material/NotInterested'),
  NotListedLocation: () => import('@mui/icons-material/NotListedLocation'),
  NotStarted: () => import('@mui/icons-material/NotStarted'),
  Note: () => import('@mui/icons-material/Note'),
  NoteAdd: () => import('@mui/icons-material/NoteAdd'),
  NoteAlt: () => import('@mui/icons-material/NoteAlt'),
  Notes: () => import('@mui/icons-material/Notes'),
  NotificationAdd: () => import('@mui/icons-material/NotificationAdd'),
  NotificationImportant: () => import('@mui/icons-material/NotificationImportant'),
  NotificationsActive: () => import('@mui/icons-material/NotificationsActive'),
  NotificationsNone: () => import('@mui/icons-material/NotificationsNone'),
  NotificationsOff: () => import('@mui/icons-material/NotificationsOff'),
  NotificationsPaused: () => import('@mui/icons-material/NotificationsPaused'),
  Numbers: () => import('@mui/icons-material/Numbers'),
  OfflineBolt: () => import('@mui/icons-material/OfflineBolt'),
  OfflinePin: () => import('@mui/icons-material/OfflinePin'),
  OfflineShare: () => import('@mui/icons-material/OfflineShare'),
  OilBarrel: () => import('@mui/icons-material/OilBarrel'),
  OnDeviceTraining: () => import('@mui/icons-material/OnDeviceTraining'),
  OndemandVideo: () => import('@mui/icons-material/OndemandVideo'),
  OneK: () => import('@mui/icons-material/OneK'),
  OneKPlus: () => import('@mui/icons-material/OneKPlus'),
  OneKk: () => import('@mui/icons-material/OneKk'),
  OnlinePrediction: () => import('@mui/icons-material/OnlinePrediction'),
  Opacity: () => import('@mui/icons-material/Opacity'),
  OpenInBrowser: () => import('@mui/icons-material/OpenInBrowser'),
  OpenInFull: () => import('@mui/icons-material/OpenInFull'),
  OpenInNew: () => import('@mui/icons-material/OpenInNew'),
  OpenInNewOff: () => import('@mui/icons-material/OpenInNewOff'),
  OpenWith: () => import('@mui/icons-material/OpenWith'),
  OtherHouses: () => import('@mui/icons-material/OtherHouses'),
  Outbound: () => import('@mui/icons-material/Outbound'),
  Outbox: () => import('@mui/icons-material/Outbox'),
  OutdoorGrill: () => import('@mui/icons-material/OutdoorGrill'),
  OutgoingMail: () => import('@mui/icons-material/OutgoingMail'),
  Outlet: () => import('@mui/icons-material/Outlet'),
  OutlinedFlag: () => import('@mui/icons-material/OutlinedFlag'),
  Output: () => import('@mui/icons-material/Output'),
  Padding: () => import('@mui/icons-material/Padding'),
  Pages: () => import('@mui/icons-material/Pages'),
  Pageview: () => import('@mui/icons-material/Pageview'),
  Paid: () => import('@mui/icons-material/Paid'),
  Palette: () => import('@mui/icons-material/Palette'),
  Pallet: () => import('@mui/icons-material/Pallet'),
  PanTool: () => import('@mui/icons-material/PanTool'),
  PanToolAlt: () => import('@mui/icons-material/PanToolAlt'),
  Panorama: () => import('@mui/icons-material/Panorama'),
  PanoramaFishEye: () => import('@mui/icons-material/PanoramaFishEye'),
  PanoramaHorizontal: () => import('@mui/icons-material/PanoramaHorizontal'),
  PanoramaHorizontalSelect: () => import('@mui/icons-material/PanoramaHorizontalSelect'),
  PanoramaPhotosphere: () => import('@mui/icons-material/PanoramaPhotosphere'),
  PanoramaPhotosphereSelect: () => import('@mui/icons-material/PanoramaPhotosphereSelect'),
  PanoramaVertical: () => import('@mui/icons-material/PanoramaVertical'),
  PanoramaVerticalSelect: () => import('@mui/icons-material/PanoramaVerticalSelect'),
  PanoramaWideAngle: () => import('@mui/icons-material/PanoramaWideAngle'),
  PanoramaWideAngleSelect: () => import('@mui/icons-material/PanoramaWideAngleSelect'),
  Paragliding: () => import('@mui/icons-material/Paragliding'),
  PartyMode: () => import('@mui/icons-material/PartyMode'),
  Password: () => import('@mui/icons-material/Password'),
  Pattern: () => import('@mui/icons-material/Pattern'),
  Pause: () => import('@mui/icons-material/Pause'),
  PauseCircle: () => import('@mui/icons-material/PauseCircle'),
  PauseCircleFilled: () => import('@mui/icons-material/PauseCircleFilled'),
  PausePresentation: () => import('@mui/icons-material/PausePresentation'),
  Payments: () => import('@mui/icons-material/Payments'),
  PedalBike: () => import('@mui/icons-material/PedalBike'),
  Pending: () => import('@mui/icons-material/Pending'),
  PendingActions: () => import('@mui/icons-material/PendingActions'),
  Pentagon: () => import('@mui/icons-material/Pentagon'),
  PeopleAlt: () => import('@mui/icons-material/PeopleAlt'),
  Percent: () => import('@mui/icons-material/Percent'),
  PermCameraMic: () => import('@mui/icons-material/PermCameraMic'),
  PermContactCalendar: () => import('@mui/icons-material/PermContactCalendar'),
  PermDataSetting: () => import('@mui/icons-material/PermDataSetting'),
  PermDeviceInformation: () => import('@mui/icons-material/PermDeviceInformation'),
  PermIdentity: () => import('@mui/icons-material/PermIdentity'),
  PermMedia: () => import('@mui/icons-material/PermMedia'),
  PermPhoneMsg: () => import('@mui/icons-material/PermPhoneMsg'),
  PermScanWifi: () => import('@mui/icons-material/PermScanWifi'),
  Person2: () => import('@mui/icons-material/Person2'),
  Person3: () => import('@mui/icons-material/Person3'),
  Person4: () => import('@mui/icons-material/Person4'),
  PersonAdd: () => import('@mui/icons-material/PersonAdd'),
  PersonAddAlt: () => import('@mui/icons-material/PersonAddAlt'),
  PersonAddAlt1: () => import('@mui/icons-material/PersonAddAlt1'),
  PersonAddDisabled: () => import('@mui/icons-material/PersonAddDisabled'),
  PersonOff: () => import('@mui/icons-material/PersonOff'),
  PersonPin: () => import('@mui/icons-material/PersonPin'),
  PersonPinCircle: () => import('@mui/icons-material/PersonPinCircle'),
  PersonRemove: () => import('@mui/icons-material/PersonRemove'),
  PersonRemoveAlt1: () => import('@mui/icons-material/PersonRemoveAlt1'),
  PersonSearch: () => import('@mui/icons-material/PersonSearch'),
  PersonalInjury: () => import('@mui/icons-material/PersonalInjury'),
  PersonalVideo: () => import('@mui/icons-material/PersonalVideo'),
  PestControl: () => import('@mui/icons-material/PestControl'),
  PestControlRodent: () => import('@mui/icons-material/PestControlRodent'),
  Phishing: () => import('@mui/icons-material/Phishing'),
  PhoneAndroid: () => import('@mui/icons-material/PhoneAndroid'),
  PhoneBluetoothSpeaker: () => import('@mui/icons-material/PhoneBluetoothSpeaker'),
  PhoneCallback: () => import('@mui/icons-material/PhoneCallback'),
  PhoneDisabled: () => import('@mui/icons-material/PhoneDisabled'),
  PhoneEnabled: () => import('@mui/icons-material/PhoneEnabled'),
  PhoneForwarded: () => import('@mui/icons-material/PhoneForwarded'),
  PhoneInTalk: () => import('@mui/icons-material/PhoneInTalk'),
  PhoneIphone: () => import('@mui/icons-material/PhoneIphone'),
  PhoneLocked: () => import('@mui/icons-material/PhoneLocked'),
  PhoneMissed: () => import('@mui/icons-material/PhoneMissed'),
  PhonePaused: () => import('@mui/icons-material/PhonePaused'),
  Phonelink: () => import('@mui/icons-material/Phonelink'),
  PhonelinkErase: () => import('@mui/icons-material/PhonelinkErase'),
  PhonelinkLock: () => import('@mui/icons-material/PhonelinkLock'),
  PhonelinkOff: () => import('@mui/icons-material/PhonelinkOff'),
  PhonelinkRing: () => import('@mui/icons-material/PhonelinkRing'),
  PhonelinkSetup: () => import('@mui/icons-material/PhonelinkSetup'),
  PhotoAlbum: () => import('@mui/icons-material/PhotoAlbum'),
  PhotoCamera: () => import('@mui/icons-material/PhotoCamera'),
  PhotoCameraBack: () => import('@mui/icons-material/PhotoCameraBack'),
  PhotoCameraFront: () => import('@mui/icons-material/PhotoCameraFront'),
  PhotoFilter: () => import('@mui/icons-material/PhotoFilter'),
  PhotoLibrary: () => import('@mui/icons-material/PhotoLibrary'),
  PhotoSizeSelectActual: () => import('@mui/icons-material/PhotoSizeSelectActual'),
  PhotoSizeSelectLarge: () => import('@mui/icons-material/PhotoSizeSelectLarge'),
  PhotoSizeSelectSmall: () => import('@mui/icons-material/PhotoSizeSelectSmall'),
  Php: () => import('@mui/icons-material/Php'),
  Piano: () => import('@mui/icons-material/Piano'),
  PianoOff: () => import('@mui/icons-material/PianoOff'),
  PictureAsPdf: () => import('@mui/icons-material/PictureAsPdf'),
  PictureInPicture: () => import('@mui/icons-material/PictureInPicture'),
  PictureInPictureAlt: () => import('@mui/icons-material/PictureInPictureAlt'),
  PieChart: () => import('@mui/icons-material/PieChart'),
  Pin: () => import('@mui/icons-material/Pin'),
  PinDrop: () => import('@mui/icons-material/PinDrop'),
  PinEnd: () => import('@mui/icons-material/PinEnd'),
  PinInvoke: () => import('@mui/icons-material/PinInvoke'),
  Pinch: () => import('@mui/icons-material/Pinch'),
  Pinterest: () => import('@mui/icons-material/Pinterest'),
  PivotTableChart: () => import('@mui/icons-material/PivotTableChart'),
  Pix: () => import('@mui/icons-material/Pix'),
  Plagiarism: () => import('@mui/icons-material/Plagiarism'),
  PlayArrow: () => import('@mui/icons-material/PlayArrow'),
  PlayCircle: () => import('@mui/icons-material/PlayCircle'),
  PlayCircleFilled: () => import('@mui/icons-material/PlayCircleFilled'),
  PlayCircleFilledWhite: () => import('@mui/icons-material/PlayCircleFilledWhite'),
  PlayDisabled: () => import('@mui/icons-material/PlayDisabled'),
  PlayForWork: () => import('@mui/icons-material/PlayForWork'),
  PlayLesson: () => import('@mui/icons-material/PlayLesson'),
  PlaylistAdd: () => import('@mui/icons-material/PlaylistAdd'),
  PlaylistAddCheck: () => import('@mui/icons-material/PlaylistAddCheck'),
  PlaylistAddCheckCircle: () => import('@mui/icons-material/PlaylistAddCheckCircle'),
  PlaylistAddCircle: () => import('@mui/icons-material/PlaylistAddCircle'),
  PlaylistPlay: () => import('@mui/icons-material/PlaylistPlay'),
  PlaylistRemove: () => import('@mui/icons-material/PlaylistRemove'),
  Plumbing: () => import('@mui/icons-material/Plumbing'),
  PlusOne: () => import('@mui/icons-material/PlusOne'),
  Podcasts: () => import('@mui/icons-material/Podcasts'),
  PointOfSale: () => import('@mui/icons-material/PointOfSale'),
  Policy: () => import('@mui/icons-material/Policy'),
  Poll: () => import('@mui/icons-material/Poll'),
  Polyline: () => import('@mui/icons-material/Polyline'),
  Pool: () => import('@mui/icons-material/Pool'),
  PortableWifiOff: () => import('@mui/icons-material/PortableWifiOff'),
  Portrait: () => import('@mui/icons-material/Portrait'),
  PostAdd: () => import('@mui/icons-material/PostAdd'),
  Power: () => import('@mui/icons-material/Power'),
  PowerInput: () => import('@mui/icons-material/PowerInput'),
  PowerOff: () => import('@mui/icons-material/PowerOff'),
  PowerSettingsNew: () => import('@mui/icons-material/PowerSettingsNew'),
  PrecisionManufacturing: () => import('@mui/icons-material/PrecisionManufacturing'),
  PregnantWoman: () => import('@mui/icons-material/PregnantWoman'),
  PresentToAll: () => import('@mui/icons-material/PresentToAll'),
  Preview: () => import('@mui/icons-material/Preview'),
  PriceChange: () => import('@mui/icons-material/PriceChange'),
  PriceCheck: () => import('@mui/icons-material/PriceCheck'),
  PrintDisabled: () => import('@mui/icons-material/PrintDisabled'),
  PriorityHigh: () => import('@mui/icons-material/PriorityHigh'),
  PrivacyTip: () => import('@mui/icons-material/PrivacyTip'),
  PrivateConnectivity: () => import('@mui/icons-material/PrivateConnectivity'),
  ProductionQuantityLimits: () => import('@mui/icons-material/ProductionQuantityLimits'),
  Propane: () => import('@mui/icons-material/Propane'),
  PropaneTank: () => import('@mui/icons-material/PropaneTank'),
  Psychology: () => import('@mui/icons-material/Psychology'),
  PsychologyAlt: () => import('@mui/icons-material/PsychologyAlt'),
  Public: () => import('@mui/icons-material/Public'),
  PublicOff: () => import('@mui/icons-material/PublicOff'),
  Publish: () => import('@mui/icons-material/Publish'),
  PublishedWithChanges: () => import('@mui/icons-material/PublishedWithChanges'),
  PunchClock: () => import('@mui/icons-material/PunchClock'),
  PushPin: () => import('@mui/icons-material/PushPin'),
  QrCode: () => import('@mui/icons-material/QrCode'),
  QrCode2: () => import('@mui/icons-material/QrCode2'),
  QrCodeScanner: () => import('@mui/icons-material/QrCodeScanner'),
  QueryBuilder: () => import('@mui/icons-material/QueryBuilder'),
  QueryStats: () => import('@mui/icons-material/QueryStats'),
  QuestionAnswer: () => import('@mui/icons-material/QuestionAnswer'),
  QuestionMark: () => import('@mui/icons-material/QuestionMark'),
  Queue: () => import('@mui/icons-material/Queue'),
  QueueMusic: () => import('@mui/icons-material/QueueMusic'),
  QueuePlayNext: () => import('@mui/icons-material/QueuePlayNext'),
  Quickreply: () => import('@mui/icons-material/Quickreply'),
  Quiz: () => import('@mui/icons-material/Quiz'),
  RMobiledata: () => import('@mui/icons-material/RMobiledata'),
  Radar: () => import('@mui/icons-material/Radar'),
  Radio: () => import('@mui/icons-material/Radio'),
  RadioButtonChecked: () => import('@mui/icons-material/RadioButtonChecked'),
  RadioButtonUnchecked: () => import('@mui/icons-material/RadioButtonUnchecked'),
  RailwayAlert: () => import('@mui/icons-material/RailwayAlert'),
  RamenDining: () => import('@mui/icons-material/RamenDining'),
  RampLeft: () => import('@mui/icons-material/RampLeft'),
  RampRight: () => import('@mui/icons-material/RampRight'),
  RateReview: () => import('@mui/icons-material/RateReview'),
  RawOff: () => import('@mui/icons-material/RawOff'),
  RawOn: () => import('@mui/icons-material/RawOn'),
  ReadMore: () => import('@mui/icons-material/ReadMore'),
  RealEstateAgent: () => import('@mui/icons-material/RealEstateAgent'),
  RebaseEdit: () => import('@mui/icons-material/RebaseEdit'),
  Receipt: () => import('@mui/icons-material/Receipt'),
  ReceiptLong: () => import('@mui/icons-material/ReceiptLong'),
  RecentActors: () => import('@mui/icons-material/RecentActors'),
  Recommend: () => import('@mui/icons-material/Recommend'),
  RecordVoiceOver: () => import('@mui/icons-material/RecordVoiceOver'),
  Rectangle: () => import('@mui/icons-material/Rectangle'),
  Recycling: () => import('@mui/icons-material/Recycling'),
  Reddit: () => import('@mui/icons-material/Reddit'),
  Redeem: () => import('@mui/icons-material/Redeem'),
  Redo: () => import('@mui/icons-material/Redo'),
  ReduceCapacity: () => import('@mui/icons-material/ReduceCapacity'),
  RememberMe: () => import('@mui/icons-material/RememberMe'),
  RemoveCircle: () => import('@mui/icons-material/RemoveCircle'),
  RemoveDone: () => import('@mui/icons-material/RemoveDone'),
  RemoveFromQueue: () => import('@mui/icons-material/RemoveFromQueue'),
  RemoveModerator: () => import('@mui/icons-material/RemoveModerator'),
  RemoveRedEye: () => import('@mui/icons-material/RemoveRedEye'),
  RemoveRoad: () => import('@mui/icons-material/RemoveRoad'),
  RemoveShoppingCart: () => import('@mui/icons-material/RemoveShoppingCart'),
  Reorder: () => import('@mui/icons-material/Reorder'),
  Repartition: () => import('@mui/icons-material/Repartition'),
  Repeat: () => import('@mui/icons-material/Repeat'),
  RepeatOn: () => import('@mui/icons-material/RepeatOn'),
  RepeatOne: () => import('@mui/icons-material/RepeatOne'),
  RepeatOneOn: () => import('@mui/icons-material/RepeatOneOn'),
  Replay: () => import('@mui/icons-material/Replay'),
  Replay10: () => import('@mui/icons-material/Replay10'),
  Replay30: () => import('@mui/icons-material/Replay30'),
  Replay5: () => import('@mui/icons-material/Replay5'),
  ReplayCircleFilled: () => import('@mui/icons-material/ReplayCircleFilled'),
  Reply: () => import('@mui/icons-material/Reply'),
  ReplyAll: () => import('@mui/icons-material/ReplyAll'),
  Report: () => import('@mui/icons-material/Report'),
  ReportGmailerrorred: () => import('@mui/icons-material/ReportGmailerrorred'),
  ReportOff: () => import('@mui/icons-material/ReportOff'),
  ReportProblem: () => import('@mui/icons-material/ReportProblem'),
  RequestPage: () => import('@mui/icons-material/RequestPage'),
  RequestQuote: () => import('@mui/icons-material/RequestQuote'),
  ResetTv: () => import('@mui/icons-material/ResetTv'),
  RestartAlt: () => import('@mui/icons-material/RestartAlt'),
  RestaurantMenu: () => import('@mui/icons-material/RestaurantMenu'),
  Restore: () => import('@mui/icons-material/Restore'),
  RestoreFromTrash: () => import('@mui/icons-material/RestoreFromTrash'),
  RestorePage: () => import('@mui/icons-material/RestorePage'),
  Reviews: () => import('@mui/icons-material/Reviews'),
  RiceBowl: () => import('@mui/icons-material/RiceBowl'),
  RingVolume: () => import('@mui/icons-material/RingVolume'),
  Rocket: () => import('@mui/icons-material/Rocket'),
  RocketLaunch: () => import('@mui/icons-material/RocketLaunch'),
  RollerShades: () => import('@mui/icons-material/RollerShades'),
  RollerShadesClosed: () => import('@mui/icons-material/RollerShadesClosed'),
  RollerSkating: () => import('@mui/icons-material/RollerSkating'),
  Roofing: () => import('@mui/icons-material/Roofing'),
  Room: () => import('@mui/icons-material/Room'),
  RoomPreferences: () => import('@mui/icons-material/RoomPreferences'),
  RoomService: () => import('@mui/icons-material/RoomService'),
  Rotate90DegreesCcw: () => import('@mui/icons-material/Rotate90DegreesCcw'),
  Rotate90DegreesCw: () => import('@mui/icons-material/Rotate90DegreesCw'),
  RotateLeft: () => import('@mui/icons-material/RotateLeft'),
  RotateRight: () => import('@mui/icons-material/RotateRight'),
  RoundaboutLeft: () => import('@mui/icons-material/RoundaboutLeft'),
  RoundaboutRight: () => import('@mui/icons-material/RoundaboutRight'),
  RoundedCorner: () => import('@mui/icons-material/RoundedCorner'),
  Route: () => import('@mui/icons-material/Route'),
  Router: () => import('@mui/icons-material/Router'),
  Rowing: () => import('@mui/icons-material/Rowing'),
  RssFeed: () => import('@mui/icons-material/RssFeed'),
  Rsvp: () => import('@mui/icons-material/Rsvp'),
  Rtt: () => import('@mui/icons-material/Rtt'),
  Rule: () => import('@mui/icons-material/Rule'),
  RuleFolder: () => import('@mui/icons-material/RuleFolder'),
  RunCircle: () => import('@mui/icons-material/RunCircle'),
  RunningWithErrors: () => import('@mui/icons-material/RunningWithErrors'),
  RvHookup: () => import('@mui/icons-material/RvHookup'),
  SafetyCheck: () => import('@mui/icons-material/SafetyCheck'),
  SafetyDivider: () => import('@mui/icons-material/SafetyDivider'),
  Sailing: () => import('@mui/icons-material/Sailing'),
  Sanitizer: () => import('@mui/icons-material/Sanitizer'),
  Satellite: () => import('@mui/icons-material/Satellite'),
  SatelliteAlt: () => import('@mui/icons-material/SatelliteAlt'),
  SaveAlt: () => import('@mui/icons-material/SaveAlt'),
  SaveAs: () => import('@mui/icons-material/SaveAs'),
  SavedSearch: () => import('@mui/icons-material/SavedSearch'),
  Savings: () => import('@mui/icons-material/Savings'),
  Scale: () => import('@mui/icons-material/Scale'),
  Scanner: () => import('@mui/icons-material/Scanner'),
  ScatterPlot: () => import('@mui/icons-material/ScatterPlot'),
  ScheduleSend: () => import('@mui/icons-material/ScheduleSend'),
  Schema: () => import('@mui/icons-material/Schema'),
  School: () => import('@mui/icons-material/School'),
  Science: () => import('@mui/icons-material/Science'),
  Score: () => import('@mui/icons-material/Score'),
  Scoreboard: () => import('@mui/icons-material/Scoreboard'),
  ScreenLockLandscape: () => import('@mui/icons-material/ScreenLockLandscape'),
  ScreenLockPortrait: () => import('@mui/icons-material/ScreenLockPortrait'),
  ScreenLockRotation: () => import('@mui/icons-material/ScreenLockRotation'),
  ScreenRotation: () => import('@mui/icons-material/ScreenRotation'),
  ScreenRotationAlt: () => import('@mui/icons-material/ScreenRotationAlt'),
  ScreenSearchDesktop: () => import('@mui/icons-material/ScreenSearchDesktop'),
  ScreenShare: () => import('@mui/icons-material/ScreenShare'),
  Screenshot: () => import('@mui/icons-material/Screenshot'),
  ScreenshotMonitor: () => import('@mui/icons-material/ScreenshotMonitor'),
  ScubaDiving: () => import('@mui/icons-material/ScubaDiving'),
  Sd: () => import('@mui/icons-material/Sd'),
  SdCard: () => import('@mui/icons-material/SdCard'),
  SdCardAlert: () => import('@mui/icons-material/SdCardAlert'),
  SdStorage: () => import('@mui/icons-material/SdStorage'),
  SearchOff: () => import('@mui/icons-material/SearchOff'),
  Security: () => import('@mui/icons-material/Security'),
  SecurityUpdate: () => import('@mui/icons-material/SecurityUpdate'),
  SecurityUpdateGood: () => import('@mui/icons-material/SecurityUpdateGood'),
  SecurityUpdateWarning: () => import('@mui/icons-material/SecurityUpdateWarning'),
  Segment: () => import('@mui/icons-material/Segment'),
  SelectAll: () => import('@mui/icons-material/SelectAll'),
  SelfImprovement: () => import('@mui/icons-material/SelfImprovement'),
  Sell: () => import('@mui/icons-material/Sell'),
  Send: () => import('@mui/icons-material/Send'),
  SendAndArchive: () => import('@mui/icons-material/SendAndArchive'),
  SendTimeExtension: () => import('@mui/icons-material/SendTimeExtension'),
  SendToMobile: () => import('@mui/icons-material/SendToMobile'),
  SensorDoor: () => import('@mui/icons-material/SensorDoor'),
  SensorOccupied: () => import('@mui/icons-material/SensorOccupied'),
  SensorWindow: () => import('@mui/icons-material/SensorWindow'),
  Sensors: () => import('@mui/icons-material/Sensors'),
  SensorsOff: () => import('@mui/icons-material/SensorsOff'),
  SentimentDissatisfied: () => import('@mui/icons-material/SentimentDissatisfied'),
  SentimentNeutral: () => import('@mui/icons-material/SentimentNeutral'),
  SentimentSatisfied: () => import('@mui/icons-material/SentimentSatisfied'),
  SentimentSatisfiedAlt: () => import('@mui/icons-material/SentimentSatisfiedAlt'),
  SentimentVeryDissatisfied: () => import('@mui/icons-material/SentimentVeryDissatisfied'),
  SentimentVerySatisfied: () => import('@mui/icons-material/SentimentVerySatisfied'),
  SetMeal: () => import('@mui/icons-material/SetMeal'),
  SettingsAccessibility: () => import('@mui/icons-material/SettingsAccessibility'),
  SettingsApplications: () => import('@mui/icons-material/SettingsApplications'),
  SettingsBackupRestore: () => import('@mui/icons-material/SettingsBackupRestore'),
  SettingsBluetooth: () => import('@mui/icons-material/SettingsBluetooth'),
  SettingsBrightness: () => import('@mui/icons-material/SettingsBrightness'),
  SettingsCell: () => import('@mui/icons-material/SettingsCell'),
  SettingsEthernet: () => import('@mui/icons-material/SettingsEthernet'),
  SettingsInputAntenna: () => import('@mui/icons-material/SettingsInputAntenna'),
  SettingsInputComponent: () => import('@mui/icons-material/SettingsInputComponent'),
  SettingsInputComposite: () => import('@mui/icons-material/SettingsInputComposite'),
  SettingsInputHdmi: () => import('@mui/icons-material/SettingsInputHdmi'),
  SettingsInputSvideo: () => import('@mui/icons-material/SettingsInputSvideo'),
  SettingsOverscan: () => import('@mui/icons-material/SettingsOverscan'),
  SettingsPhone: () => import('@mui/icons-material/SettingsPhone'),
  SettingsPower: () => import('@mui/icons-material/SettingsPower'),
  SettingsRemote: () => import('@mui/icons-material/SettingsRemote'),
  SettingsSuggest: () => import('@mui/icons-material/SettingsSuggest'),
  SettingsSystemDaydream: () => import('@mui/icons-material/SettingsSystemDaydream'),
  SettingsVoice: () => import('@mui/icons-material/SettingsVoice'),
  SevenK: () => import('@mui/icons-material/SevenK'),
  SevenKPlus: () => import('@mui/icons-material/SevenKPlus'),
  SevenMp: () => import('@mui/icons-material/SevenMp'),
  SeventeenMp: () => import('@mui/icons-material/SeventeenMp'),
  SevereCold: () => import('@mui/icons-material/SevereCold'),
  ShapeLine: () => import('@mui/icons-material/ShapeLine'),
  ShareLocation: () => import('@mui/icons-material/ShareLocation'),
  Shelves: () => import('@mui/icons-material/Shelves'),
  Shield: () => import('@mui/icons-material/Shield'),
  ShieldMoon: () => import('@mui/icons-material/ShieldMoon'),
  Shop: () => import('@mui/icons-material/Shop'),
  Shop2: () => import('@mui/icons-material/Shop2'),
  ShopTwo: () => import('@mui/icons-material/ShopTwo'),
  ShoppingBag: () => import('@mui/icons-material/ShoppingBag'),
  ShoppingBasket: () => import('@mui/icons-material/ShoppingBasket'),
  ShoppingCart: () => import('@mui/icons-material/ShoppingCart'),
  ShoppingCartCheckout: () => import('@mui/icons-material/ShoppingCartCheckout'),
  ShortText: () => import('@mui/icons-material/ShortText'),
  Shortcut: () => import('@mui/icons-material/Shortcut'),
  ShowChart: () => import('@mui/icons-material/ShowChart'),
  Shower: () => import('@mui/icons-material/Shower'),
  Shuffle: () => import('@mui/icons-material/Shuffle'),
  ShuffleOn: () => import('@mui/icons-material/ShuffleOn'),
  ShutterSpeed: () => import('@mui/icons-material/ShutterSpeed'),
  Sick: () => import('@mui/icons-material/Sick'),
  SignLanguage: () => import('@mui/icons-material/SignLanguage'),
  SignalCellular0Bar: () => import('@mui/icons-material/SignalCellular0Bar'),
  SignalCellular1Bar: () => import('@mui/icons-material/SignalCellular1Bar'),
  SignalCellular2Bar: () => import('@mui/icons-material/SignalCellular2Bar'),
  SignalCellular3Bar: () => import('@mui/icons-material/SignalCellular3Bar'),
  SignalCellular4Bar: () => import('@mui/icons-material/SignalCellular4Bar'),
  SignalCellularAlt: () => import('@mui/icons-material/SignalCellularAlt'),
  SignalCellularAlt1Bar: () => import('@mui/icons-material/SignalCellularAlt1Bar'),
  SignalCellularAlt2Bar: () => import('@mui/icons-material/SignalCellularAlt2Bar'),
  SignalCellularConnectedNoInternet0Bar: () => import('@mui/icons-material/SignalCellularConnectedNoInternet0Bar'),
  SignalCellularConnectedNoInternet1Bar: () => import('@mui/icons-material/SignalCellularConnectedNoInternet1Bar'),
  SignalCellularConnectedNoInternet2Bar: () => import('@mui/icons-material/SignalCellularConnectedNoInternet2Bar'),
  SignalCellularConnectedNoInternet3Bar: () => import('@mui/icons-material/SignalCellularConnectedNoInternet3Bar'),
  SignalCellularConnectedNoInternet4Bar: () => import('@mui/icons-material/SignalCellularConnectedNoInternet4Bar'),
  SignalCellularNoSim: () => import('@mui/icons-material/SignalCellularNoSim'),
  SignalCellularNodata: () => import('@mui/icons-material/SignalCellularNodata'),
  SignalCellularNull: () => import('@mui/icons-material/SignalCellularNull'),
  SignalCellularOff: () => import('@mui/icons-material/SignalCellularOff'),
  SignalWifi0Bar: () => import('@mui/icons-material/SignalWifi0Bar'),
  SignalWifi1Bar: () => import('@mui/icons-material/SignalWifi1Bar'),
  SignalWifi1BarLock: () => import('@mui/icons-material/SignalWifi1BarLock'),
  SignalWifi2Bar: () => import('@mui/icons-material/SignalWifi2Bar'),
  SignalWifi2BarLock: () => import('@mui/icons-material/SignalWifi2BarLock'),
  SignalWifi3Bar: () => import('@mui/icons-material/SignalWifi3Bar'),
  SignalWifi3BarLock: () => import('@mui/icons-material/SignalWifi3BarLock'),
  SignalWifi4Bar: () => import('@mui/icons-material/SignalWifi4Bar'),
  SignalWifi4BarLock: () => import('@mui/icons-material/SignalWifi4BarLock'),
  SignalWifiBad: () => import('@mui/icons-material/SignalWifiBad'),
  SignalWifiConnectedNoInternet4: () => import('@mui/icons-material/SignalWifiConnectedNoInternet4'),
  SignalWifiOff: () => import('@mui/icons-material/SignalWifiOff'),
  SignalWifiStatusbar4Bar: () => import('@mui/icons-material/SignalWifiStatusbar4Bar'),
  SignalWifiStatusbarConnectedNoInternet4: () => import('@mui/icons-material/SignalWifiStatusbarConnectedNoInternet4'),
  SignalWifiStatusbarNull: () => import('@mui/icons-material/SignalWifiStatusbarNull'),
  Signpost: () => import('@mui/icons-material/Signpost'),
  SimCard: () => import('@mui/icons-material/SimCard'),
  SimCardAlert: () => import('@mui/icons-material/SimCardAlert'),
  SimCardDownload: () => import('@mui/icons-material/SimCardDownload'),
  SingleBed: () => import('@mui/icons-material/SingleBed'),
  Sip: () => import('@mui/icons-material/Sip'),
  SixK: () => import('@mui/icons-material/SixK'),
  SixKPlus: () => import('@mui/icons-material/SixKPlus'),
  SixMp: () => import('@mui/icons-material/SixMp'),
  SixteenMp: () => import('@mui/icons-material/SixteenMp'),
  SixtyFps: () => import('@mui/icons-material/SixtyFps'),
  SixtyFpsSelect: () => import('@mui/icons-material/SixtyFpsSelect'),
  Skateboarding: () => import('@mui/icons-material/Skateboarding'),
  SkipNext: () => import('@mui/icons-material/SkipNext'),
  SkipPrevious: () => import('@mui/icons-material/SkipPrevious'),
  Sledding: () => import('@mui/icons-material/Sledding'),
  Slideshow: () => import('@mui/icons-material/Slideshow'),
  SlowMotionVideo: () => import('@mui/icons-material/SlowMotionVideo'),
  SmartButton: () => import('@mui/icons-material/SmartButton'),
  SmartDisplay: () => import('@mui/icons-material/SmartDisplay'),
  SmartScreen: () => import('@mui/icons-material/SmartScreen'),
  SmartToy: () => import('@mui/icons-material/SmartToy'),
  Smartphone: () => import('@mui/icons-material/Smartphone'),
  SmokeFree: () => import('@mui/icons-material/SmokeFree'),
  SmokingRooms: () => import('@mui/icons-material/SmokingRooms'),
  SmsFailed: () => import('@mui/icons-material/SmsFailed'),
  SnippetFolder: () => import('@mui/icons-material/SnippetFolder'),
  Snooze: () => import('@mui/icons-material/Snooze'),
  Snowboarding: () => import('@mui/icons-material/Snowboarding'),
  Snowing: () => import('@mui/icons-material/Snowing'),
  Snowmobile: () => import('@mui/icons-material/Snowmobile'),
  Snowshoeing: () => import('@mui/icons-material/Snowshoeing'),
  Soap: () => import('@mui/icons-material/Soap'),
  SocialDistance: () => import('@mui/icons-material/SocialDistance'),
  SolarPower: () => import('@mui/icons-material/SolarPower'),
  Sort: () => import('@mui/icons-material/Sort'),
  SortByAlpha: () => import('@mui/icons-material/SortByAlpha'),
  Sos: () => import('@mui/icons-material/Sos'),
  SoupKitchen: () => import('@mui/icons-material/SoupKitchen'),
  Source: () => import('@mui/icons-material/Source'),
  South: () => import('@mui/icons-material/South'),
  SouthAmerica: () => import('@mui/icons-material/SouthAmerica'),
  SouthEast: () => import('@mui/icons-material/SouthEast'),
  SouthWest: () => import('@mui/icons-material/SouthWest'),
  Spa: () => import('@mui/icons-material/Spa'),
  SpaceBar: () => import('@mui/icons-material/SpaceBar'),
  SpaceDashboard: () => import('@mui/icons-material/SpaceDashboard'),
  SpatialAudio: () => import('@mui/icons-material/SpatialAudio'),
  SpatialAudioOff: () => import('@mui/icons-material/SpatialAudioOff'),
  SpatialTracking: () => import('@mui/icons-material/SpatialTracking'),
  Speaker: () => import('@mui/icons-material/Speaker'),
  SpeakerGroup: () => import('@mui/icons-material/SpeakerGroup'),
  SpeakerNotes: () => import('@mui/icons-material/SpeakerNotes'),
  SpeakerNotesOff: () => import('@mui/icons-material/SpeakerNotesOff'),
  SpeakerPhone: () => import('@mui/icons-material/SpeakerPhone'),
  Speed: () => import('@mui/icons-material/Speed'),
  Spellcheck: () => import('@mui/icons-material/Spellcheck'),
  Splitscreen: () => import('@mui/icons-material/Splitscreen'),
  Spoke: () => import('@mui/icons-material/Spoke'),
  Sports: () => import('@mui/icons-material/Sports'),
  SportsBar: () => import('@mui/icons-material/SportsBar'),
  SportsBaseball: () => import('@mui/icons-material/SportsBaseball'),
  SportsBasketball: () => import('@mui/icons-material/SportsBasketball'),
  SportsCricket: () => import('@mui/icons-material/SportsCricket'),
  SportsEsports: () => import('@mui/icons-material/SportsEsports'),
  SportsFootball: () => import('@mui/icons-material/SportsFootball'),
  SportsGolf: () => import('@mui/icons-material/SportsGolf'),
  SportsGymnastics: () => import('@mui/icons-material/SportsGymnastics'),
  SportsHandball: () => import('@mui/icons-material/SportsHandball'),
  SportsHockey: () => import('@mui/icons-material/SportsHockey'),
  SportsKabaddi: () => import('@mui/icons-material/SportsKabaddi'),
  SportsMartialArts: () => import('@mui/icons-material/SportsMartialArts'),
  SportsMma: () => import('@mui/icons-material/SportsMma'),
  SportsMotorsports: () => import('@mui/icons-material/SportsMotorsports'),
  SportsRugby: () => import('@mui/icons-material/SportsRugby'),
  SportsScore: () => import('@mui/icons-material/SportsScore'),
  SportsSoccer: () => import('@mui/icons-material/SportsSoccer'),
  SportsTennis: () => import('@mui/icons-material/SportsTennis'),
  SportsVolleyball: () => import('@mui/icons-material/SportsVolleyball'),
  Square: () => import('@mui/icons-material/Square'),
  SquareFoot: () => import('@mui/icons-material/SquareFoot'),
  SsidChart: () => import('@mui/icons-material/SsidChart'),
  StackedBarChart: () => import('@mui/icons-material/StackedBarChart'),
  StackedLineChart: () => import('@mui/icons-material/StackedLineChart'),
  Stadium: () => import('@mui/icons-material/Stadium'),
  Stairs: () => import('@mui/icons-material/Stairs'),
  StarBorderPurple500: () => import('@mui/icons-material/StarBorderPurple500'),
  StarHalf: () => import('@mui/icons-material/StarHalf'),
  StarPurple500: () => import('@mui/icons-material/StarPurple500'),
  StarRate: () => import('@mui/icons-material/StarRate'),
  Stars: () => import('@mui/icons-material/Stars'),
  Start: () => import('@mui/icons-material/Start'),
  StayCurrentLandscape: () => import('@mui/icons-material/StayCurrentLandscape'),
  StayCurrentPortrait: () => import('@mui/icons-material/StayCurrentPortrait'),
  StayPrimaryLandscape: () => import('@mui/icons-material/StayPrimaryLandscape'),
  StayPrimaryPortrait: () => import('@mui/icons-material/StayPrimaryPortrait'),
  StickyNote2: () => import('@mui/icons-material/StickyNote2'),
  Stop: () => import('@mui/icons-material/Stop'),
  StopCircle: () => import('@mui/icons-material/StopCircle'),
  StopScreenShare: () => import('@mui/icons-material/StopScreenShare'),
  Storage: () => import('@mui/icons-material/Storage'),
  Store: () => import('@mui/icons-material/Store'),
  StoreMallDirectory: () => import('@mui/icons-material/StoreMallDirectory'),
  Storefront: () => import('@mui/icons-material/Storefront'),
  Storm: () => import('@mui/icons-material/Storm'),
  Straight: () => import('@mui/icons-material/Straight'),
  Straighten: () => import('@mui/icons-material/Straighten'),
  Stream: () => import('@mui/icons-material/Stream'),
  Streetview: () => import('@mui/icons-material/Streetview'),
  StrikethroughS: () => import('@mui/icons-material/StrikethroughS'),
  Stroller: () => import('@mui/icons-material/Stroller'),
  Style: () => import('@mui/icons-material/Style'),
  SubdirectoryArrowLeft: () => import('@mui/icons-material/SubdirectoryArrowLeft'),
  SubdirectoryArrowRight: () => import('@mui/icons-material/SubdirectoryArrowRight'),
  Subject: () => import('@mui/icons-material/Subject'),
  Subscript: () => import('@mui/icons-material/Subscript'),
  Subscriptions: () => import('@mui/icons-material/Subscriptions'),
  Subtitles: () => import('@mui/icons-material/Subtitles'),
  SubtitlesOff: () => import('@mui/icons-material/SubtitlesOff'),
  Subway: () => import('@mui/icons-material/Subway'),
  Summarize: () => import('@mui/icons-material/Summarize'),
  Sunny: () => import('@mui/icons-material/Sunny'),
  SunnySnowing: () => import('@mui/icons-material/SunnySnowing'),
  Superscript: () => import('@mui/icons-material/Superscript'),
  SupervisedUserCircle: () => import('@mui/icons-material/SupervisedUserCircle'),
  SupervisorAccount: () => import('@mui/icons-material/SupervisorAccount'),
  Support: () => import('@mui/icons-material/Support'),
  SupportAgent: () => import('@mui/icons-material/SupportAgent'),
  Surfing: () => import('@mui/icons-material/Surfing'),
  SurroundSound: () => import('@mui/icons-material/SurroundSound'),
  SwapCalls: () => import('@mui/icons-material/SwapCalls'),
  SwapHoriz: () => import('@mui/icons-material/SwapHoriz'),
  SwapHorizontalCircle: () => import('@mui/icons-material/SwapHorizontalCircle'),
  SwapVert: () => import('@mui/icons-material/SwapVert'),
  SwapVerticalCircle: () => import('@mui/icons-material/SwapVerticalCircle'),
  Swipe: () => import('@mui/icons-material/Swipe'),
  SwipeDown: () => import('@mui/icons-material/SwipeDown'),
  SwipeDownAlt: () => import('@mui/icons-material/SwipeDownAlt'),
  SwipeLeft: () => import('@mui/icons-material/SwipeLeft'),
  SwipeLeftAlt: () => import('@mui/icons-material/SwipeLeftAlt'),
  SwipeRight: () => import('@mui/icons-material/SwipeRight'),
  SwipeRightAlt: () => import('@mui/icons-material/SwipeRightAlt'),
  SwipeUp: () => import('@mui/icons-material/SwipeUp'),
  SwipeUpAlt: () => import('@mui/icons-material/SwipeUpAlt'),
  SwipeVertical: () => import('@mui/icons-material/SwipeVertical'),
  SwitchAccessShortcut: () => import('@mui/icons-material/SwitchAccessShortcut'),
  SwitchAccessShortcutAdd: () => import('@mui/icons-material/SwitchAccessShortcutAdd'),
  SwitchAccount: () => import('@mui/icons-material/SwitchAccount'),
  SwitchCamera: () => import('@mui/icons-material/SwitchCamera'),
  SwitchLeft: () => import('@mui/icons-material/SwitchLeft'),
  SwitchRight: () => import('@mui/icons-material/SwitchRight'),
  SwitchVideo: () => import('@mui/icons-material/SwitchVideo'),
  Synagogue: () => import('@mui/icons-material/Synagogue'),
  Sync: () => import('@mui/icons-material/Sync'),
  SyncAlt: () => import('@mui/icons-material/SyncAlt'),
  SyncDisabled: () => import('@mui/icons-material/SyncDisabled'),
  SyncLock: () => import('@mui/icons-material/SyncLock'),
  SyncProblem: () => import('@mui/icons-material/SyncProblem'),
  SystemSecurityUpdate: () => import('@mui/icons-material/SystemSecurityUpdate'),
  SystemSecurityUpdateGood: () => import('@mui/icons-material/SystemSecurityUpdateGood'),
  SystemSecurityUpdateWarning: () => import('@mui/icons-material/SystemSecurityUpdateWarning'),
  SystemUpdate: () => import('@mui/icons-material/SystemUpdate'),
  SystemUpdateAlt: () => import('@mui/icons-material/SystemUpdateAlt'),
  Tab: () => import('@mui/icons-material/Tab'),
  TabUnselected: () => import('@mui/icons-material/TabUnselected'),
  TableBar: () => import('@mui/icons-material/TableBar'),
  TableChart: () => import('@mui/icons-material/TableChart'),
  TableRestaurant: () => import('@mui/icons-material/TableRestaurant'),
  TableRows: () => import('@mui/icons-material/TableRows'),
  TableView: () => import('@mui/icons-material/TableView'),
  Tablet: () => import('@mui/icons-material/Tablet'),
  TabletAndroid: () => import('@mui/icons-material/TabletAndroid'),
  TabletMac: () => import('@mui/icons-material/TabletMac'),
  Tag: () => import('@mui/icons-material/Tag'),
  TagFaces: () => import('@mui/icons-material/TagFaces'),
  TakeoutDining: () => import('@mui/icons-material/TakeoutDining'),
  TapAndPlay: () => import('@mui/icons-material/TapAndPlay'),
  Tapas: () => import('@mui/icons-material/Tapas'),
  Task: () => import('@mui/icons-material/Task'),
  TaskAlt: () => import('@mui/icons-material/TaskAlt'),
  TaxiAlert: () => import('@mui/icons-material/TaxiAlert'),
  Telegram: () => import('@mui/icons-material/Telegram'),
  TempleBuddhist: () => import('@mui/icons-material/TempleBuddhist'),
  TempleHindu: () => import('@mui/icons-material/TempleHindu'),
  TenMp: () => import('@mui/icons-material/TenMp'),
  Terminal: () => import('@mui/icons-material/Terminal'),
  TextDecrease: () => import('@mui/icons-material/TextDecrease'),
  TextFields: () => import('@mui/icons-material/TextFields'),
  TextFormat: () => import('@mui/icons-material/TextFormat'),
  TextIncrease: () => import('@mui/icons-material/TextIncrease'),
  TextRotateUp: () => import('@mui/icons-material/TextRotateUp'),
  TextRotateVertical: () => import('@mui/icons-material/TextRotateVertical'),
  TextRotationAngledown: () => import('@mui/icons-material/TextRotationAngledown'),
  TextRotationAngleup: () => import('@mui/icons-material/TextRotationAngleup'),
  TextRotationDown: () => import('@mui/icons-material/TextRotationDown'),
  TextRotationNone: () => import('@mui/icons-material/TextRotationNone'),
  TextSnippet: () => import('@mui/icons-material/TextSnippet'),
  Textsms: () => import('@mui/icons-material/Textsms'),
  Texture: () => import('@mui/icons-material/Texture'),
  TheaterComedy: () => import('@mui/icons-material/TheaterComedy'),
  Theaters: () => import('@mui/icons-material/Theaters'),
  Thermostat: () => import('@mui/icons-material/Thermostat'),
  ThermostatAuto: () => import('@mui/icons-material/ThermostatAuto'),
  ThirteenMp: () => import('@mui/icons-material/ThirteenMp'),
  ThirtyFps: () => import('@mui/icons-material/ThirtyFps'),
  ThirtyFpsSelect: () => import('@mui/icons-material/ThirtyFpsSelect'),
  ThreeDRotation: () => import('@mui/icons-material/ThreeDRotation'),
  ThreeGMobiledata: () => import('@mui/icons-material/ThreeGMobiledata'),
  ThreeK: () => import('@mui/icons-material/ThreeK'),
  ThreeKPlus: () => import('@mui/icons-material/ThreeKPlus'),
  ThreeMp: () => import('@mui/icons-material/ThreeMp'),
  ThreeP: () => import('@mui/icons-material/ThreeP'),
  ThreeSixty: () => import('@mui/icons-material/ThreeSixty'),
  ThumbDown: () => import('@mui/icons-material/ThumbDown'),
  ThumbDownAlt: () => import('@mui/icons-material/ThumbDownAlt'),
  ThumbDownOffAlt: () => import('@mui/icons-material/ThumbDownOffAlt'),
  ThumbUp: () => import('@mui/icons-material/ThumbUp'),
  ThumbUpAlt: () => import('@mui/icons-material/ThumbUpAlt'),
  ThumbUpOffAlt: () => import('@mui/icons-material/ThumbUpOffAlt'),
  ThumbsUpDown: () => import('@mui/icons-material/ThumbsUpDown'),
  TimeToLeave: () => import('@mui/icons-material/TimeToLeave'),
  Timelapse: () => import('@mui/icons-material/Timelapse'),
  Timeline: () => import('@mui/icons-material/Timeline'),
  Timer10: () => import('@mui/icons-material/Timer10'),
  Timer10Select: () => import('@mui/icons-material/Timer10Select'),
  Timer3: () => import('@mui/icons-material/Timer3'),
  Timer3Select: () => import('@mui/icons-material/Timer3Select'),
  TimerOff: () => import('@mui/icons-material/TimerOff'),
  TimesOneMobiledata: () => import('@mui/icons-material/TimesOneMobiledata'),
  TipsAndUpdates: () => import('@mui/icons-material/TipsAndUpdates'),
  TireRepair: () => import('@mui/icons-material/TireRepair'),
  Title: () => import('@mui/icons-material/Title'),
  Toc: () => import('@mui/icons-material/Toc'),
  ToggleOff: () => import('@mui/icons-material/ToggleOff'),
  ToggleOn: () => import('@mui/icons-material/ToggleOn'),
  Token: () => import('@mui/icons-material/Token'),
  Toll: () => import('@mui/icons-material/Toll'),
  Tonality: () => import('@mui/icons-material/Tonality'),
  Topic: () => import('@mui/icons-material/Topic'),
  Tornado: () => import('@mui/icons-material/Tornado'),
  TouchApp: () => import('@mui/icons-material/TouchApp'),
  Tour: () => import('@mui/icons-material/Tour'),
  Toys: () => import('@mui/icons-material/Toys'),
  TrackChanges: () => import('@mui/icons-material/TrackChanges'),
  Traffic: () => import('@mui/icons-material/Traffic'),
  Train: () => import('@mui/icons-material/Train'),
  Tram: () => import('@mui/icons-material/Tram'),
  Transcribe: () => import('@mui/icons-material/Transcribe'),
  TransferWithinAStation: () => import('@mui/icons-material/TransferWithinAStation'),
  Transform: () => import('@mui/icons-material/Transform'),
  Transgender: () => import('@mui/icons-material/Transgender'),
  TransitEnterexit: () => import('@mui/icons-material/TransitEnterexit'),
  Translate: () => import('@mui/icons-material/Translate'),
  TravelExplore: () => import('@mui/icons-material/TravelExplore'),
  TrendingDown: () => import('@mui/icons-material/TrendingDown'),
  TrendingFlat: () => import('@mui/icons-material/TrendingFlat'),
  TrendingUp: () => import('@mui/icons-material/TrendingUp'),
  TripOrigin: () => import('@mui/icons-material/TripOrigin'),
  Trolley: () => import('@mui/icons-material/Trolley'),
  Troubleshoot: () => import('@mui/icons-material/Troubleshoot'),
  Try: () => import('@mui/icons-material/Try'),
  Tsunami: () => import('@mui/icons-material/Tsunami'),
  Tty: () => import('@mui/icons-material/Tty'),
  Tune: () => import('@mui/icons-material/Tune'),
  Tungsten: () => import('@mui/icons-material/Tungsten'),
  TurnLeft: () => import('@mui/icons-material/TurnLeft'),
  TurnRight: () => import('@mui/icons-material/TurnRight'),
  TurnSharpLeft: () => import('@mui/icons-material/TurnSharpLeft'),
  TurnSharpRight: () => import('@mui/icons-material/TurnSharpRight'),
  TurnSlightLeft: () => import('@mui/icons-material/TurnSlightLeft'),
  TurnSlightRight: () => import('@mui/icons-material/TurnSlightRight'),
  TurnedIn: () => import('@mui/icons-material/TurnedIn'),
  TurnedInNot: () => import('@mui/icons-material/TurnedInNot'),
  Tv: () => import('@mui/icons-material/Tv'),
  TvOff: () => import('@mui/icons-material/TvOff'),
  TwelveMp: () => import('@mui/icons-material/TwelveMp'),
  TwentyFourMp: () => import('@mui/icons-material/TwentyFourMp'),
  TwentyOneMp: () => import('@mui/icons-material/TwentyOneMp'),
  TwentyThreeMp: () => import('@mui/icons-material/TwentyThreeMp'),
  TwentyTwoMp: () => import('@mui/icons-material/TwentyTwoMp'),
  TwentyZeroMp: () => import('@mui/icons-material/TwentyZeroMp'),
  Twitter: () => import('@mui/icons-material/Twitter'),
  TwoK: () => import('@mui/icons-material/TwoK'),
  TwoKPlus: () => import('@mui/icons-material/TwoKPlus'),
  TwoMp: () => import('@mui/icons-material/TwoMp'),
  TwoWheeler: () => import('@mui/icons-material/TwoWheeler'),
  TypeSpecimen: () => import('@mui/icons-material/TypeSpecimen'),
  UTurnLeft: () => import('@mui/icons-material/UTurnLeft'),
  UTurnRight: () => import('@mui/icons-material/UTurnRight'),
  Umbrella: () => import('@mui/icons-material/Umbrella'),
  Unarchive: () => import('@mui/icons-material/Unarchive'),
  Undo: () => import('@mui/icons-material/Undo'),
  UnfoldLess: () => import('@mui/icons-material/UnfoldLess'),
  UnfoldLessDouble: () => import('@mui/icons-material/UnfoldLessDouble'),
  UnfoldMore: () => import('@mui/icons-material/UnfoldMore'),
  UnfoldMoreDouble: () => import('@mui/icons-material/UnfoldMoreDouble'),
  Unpublished: () => import('@mui/icons-material/Unpublished'),
  Unsubscribe: () => import('@mui/icons-material/Unsubscribe'),
  Upcoming: () => import('@mui/icons-material/Upcoming'),
  Update: () => import('@mui/icons-material/Update'),
  UpdateDisabled: () => import('@mui/icons-material/UpdateDisabled'),
  Upgrade: () => import('@mui/icons-material/Upgrade'),
  UploadFile: () => import('@mui/icons-material/UploadFile'),
  Usb: () => import('@mui/icons-material/Usb'),
  UsbOff: () => import('@mui/icons-material/UsbOff'),
  Vaccines: () => import('@mui/icons-material/Vaccines'),
  VapeFree: () => import('@mui/icons-material/VapeFree'),
  VapingRooms: () => import('@mui/icons-material/VapingRooms'),
  Verified: () => import('@mui/icons-material/Verified'),
  VerifiedUser: () => import('@mui/icons-material/VerifiedUser'),
  VerticalAlignBottom: () => import('@mui/icons-material/VerticalAlignBottom'),
  VerticalAlignCenter: () => import('@mui/icons-material/VerticalAlignCenter'),
  VerticalAlignTop: () => import('@mui/icons-material/VerticalAlignTop'),
  VerticalShades: () => import('@mui/icons-material/VerticalShades'),
  VerticalShadesClosed: () => import('@mui/icons-material/VerticalShadesClosed'),
  VerticalSplit: () => import('@mui/icons-material/VerticalSplit'),
  Vibration: () => import('@mui/icons-material/Vibration'),
  VideoCall: () => import('@mui/icons-material/VideoCall'),
  VideoCameraBack: () => import('@mui/icons-material/VideoCameraBack'),
  VideoCameraFront: () => import('@mui/icons-material/VideoCameraFront'),
  VideoChat: () => import('@mui/icons-material/VideoChat'),
  VideoFile: () => import('@mui/icons-material/VideoFile'),
  VideoLabel: () => import('@mui/icons-material/VideoLabel'),
  VideoLibrary: () => import('@mui/icons-material/VideoLibrary'),
  VideoSettings: () => import('@mui/icons-material/VideoSettings'),
  VideoStable: () => import('@mui/icons-material/VideoStable'),
  Videocam: () => import('@mui/icons-material/Videocam'),
  VideocamOff: () => import('@mui/icons-material/VideocamOff'),
  VideogameAsset: () => import('@mui/icons-material/VideogameAsset'),
  VideogameAssetOff: () => import('@mui/icons-material/VideogameAssetOff'),
  ViewAgenda: () => import('@mui/icons-material/ViewAgenda'),
  ViewArray: () => import('@mui/icons-material/ViewArray'),
  ViewCarousel: () => import('@mui/icons-material/ViewCarousel'),
  ViewColumn: () => import('@mui/icons-material/ViewColumn'),
  ViewComfy: () => import('@mui/icons-material/ViewComfy'),
  ViewComfyAlt: () => import('@mui/icons-material/ViewComfyAlt'),
  ViewCompact: () => import('@mui/icons-material/ViewCompact'),
  ViewCompactAlt: () => import('@mui/icons-material/ViewCompactAlt'),
  ViewCozy: () => import('@mui/icons-material/ViewCozy'),
  ViewDay: () => import('@mui/icons-material/ViewDay'),
  ViewHeadline: () => import('@mui/icons-material/ViewHeadline'),
  ViewInAr: () => import('@mui/icons-material/ViewInAr'),
  ViewKanban: () => import('@mui/icons-material/ViewKanban'),
  ViewList: () => import('@mui/icons-material/ViewList'),
  ViewModule: () => import('@mui/icons-material/ViewModule'),
  ViewQuilt: () => import('@mui/icons-material/ViewQuilt'),
  ViewSidebar: () => import('@mui/icons-material/ViewSidebar'),
  ViewStream: () => import('@mui/icons-material/ViewStream'),
  ViewTimeline: () => import('@mui/icons-material/ViewTimeline'),
  ViewWeek: () => import('@mui/icons-material/ViewWeek'),
  Vignette: () => import('@mui/icons-material/Vignette'),
  Villa: () => import('@mui/icons-material/Villa'),
  VoiceChat: () => import('@mui/icons-material/VoiceChat'),
  VoiceOverOff: () => import('@mui/icons-material/VoiceOverOff'),
  Voicemail: () => import('@mui/icons-material/Voicemail'),
  Volcano: () => import('@mui/icons-material/Volcano'),
  VolumeDown: () => import('@mui/icons-material/VolumeDown'),
  VolumeDownAlt: () => import('@mui/icons-material/VolumeDownAlt'),
  VolumeMute: () => import('@mui/icons-material/VolumeMute'),
  VolumeOff: () => import('@mui/icons-material/VolumeOff'),
  VolumeUp: () => import('@mui/icons-material/VolumeUp'),
  VolunteerActivism: () => import('@mui/icons-material/VolunteerActivism'),
  VpnKey: () => import('@mui/icons-material/VpnKey'),
  VpnKeyOff: () => import('@mui/icons-material/VpnKeyOff'),
  VpnLock: () => import('@mui/icons-material/VpnLock'),
  Vrpano: () => import('@mui/icons-material/Vrpano'),
  Wallet: () => import('@mui/icons-material/Wallet'),
  Wallpaper: () => import('@mui/icons-material/Wallpaper'),
  Warehouse: () => import('@mui/icons-material/Warehouse'),
  WarningAmber: () => import('@mui/icons-material/WarningAmber'),
  Wash: () => import('@mui/icons-material/Wash'),
  Watch: () => import('@mui/icons-material/Watch'),
  WatchLater: () => import('@mui/icons-material/WatchLater'),
  WatchOff: () => import('@mui/icons-material/WatchOff'),
  Water: () => import('@mui/icons-material/Water'),
  WaterDamage: () => import('@mui/icons-material/WaterDamage'),
  WaterfallChart: () => import('@mui/icons-material/WaterfallChart'),
  Waves: () => import('@mui/icons-material/Waves'),
  WavingHand: () => import('@mui/icons-material/WavingHand'),
  WbAuto: () => import('@mui/icons-material/WbAuto'),
  WbCloudy: () => import('@mui/icons-material/WbCloudy'),
  WbIncandescent: () => import('@mui/icons-material/WbIncandescent'),
  WbIridescent: () => import('@mui/icons-material/WbIridescent'),
  WbShade: () => import('@mui/icons-material/WbShade'),
  WbTwighlight: () => import('@mui/icons-material/WbTwighlight'),
  WbTwilight: () => import('@mui/icons-material/WbTwilight'),
  Web: () => import('@mui/icons-material/Web'),
  WebAsset: () => import('@mui/icons-material/WebAsset'),
  WebAssetOff: () => import('@mui/icons-material/WebAssetOff'),
  WebStories: () => import('@mui/icons-material/WebStories'),
  Webhook: () => import('@mui/icons-material/Webhook'),
  Weekend: () => import('@mui/icons-material/Weekend'),
  West: () => import('@mui/icons-material/West'),
  WhatsApp: () => import('@mui/icons-material/WhatsApp'),
  Whatshot: () => import('@mui/icons-material/Whatshot'),
  WheelchairPickup: () => import('@mui/icons-material/WheelchairPickup'),
  WhereToVote: () => import('@mui/icons-material/WhereToVote'),
  Widgets: () => import('@mui/icons-material/Widgets'),
  WidthFull: () => import('@mui/icons-material/WidthFull'),
  WidthNormal: () => import('@mui/icons-material/WidthNormal'),
  WidthWide: () => import('@mui/icons-material/WidthWide'),
  Wifi: () => import('@mui/icons-material/Wifi'),
  Wifi1Bar: () => import('@mui/icons-material/Wifi1Bar'),
  Wifi2Bar: () => import('@mui/icons-material/Wifi2Bar'),
  WifiCalling: () => import('@mui/icons-material/WifiCalling'),
  WifiCalling3: () => import('@mui/icons-material/WifiCalling3'),
  WifiChannel: () => import('@mui/icons-material/WifiChannel'),
  WifiFind: () => import('@mui/icons-material/WifiFind'),
  WifiLock: () => import('@mui/icons-material/WifiLock'),
  WifiOff: () => import('@mui/icons-material/WifiOff'),
  WifiPassword: () => import('@mui/icons-material/WifiPassword'),
  WifiProtectedSetup: () => import('@mui/icons-material/WifiProtectedSetup'),
  WifiTethering: () => import('@mui/icons-material/WifiTethering'),
  WifiTetheringError: () => import('@mui/icons-material/WifiTetheringError'),
  WifiTetheringOff: () => import('@mui/icons-material/WifiTetheringOff'),
  WindPower: () => import('@mui/icons-material/WindPower'),
  Window: () => import('@mui/icons-material/Window'),
  WineBar: () => import('@mui/icons-material/WineBar'),
  Woman: () => import('@mui/icons-material/Woman'),
  Woman2: () => import('@mui/icons-material/Woman2'),
  Work: () => import('@mui/icons-material/Work'),
  WorkHistory: () => import('@mui/icons-material/WorkHistory'),
  WorkOff: () => import('@mui/icons-material/WorkOff'),
  WorkspacePremium: () => import('@mui/icons-material/WorkspacePremium'),
  Workspaces: () => import('@mui/icons-material/Workspaces'),
  WorkspacesFilled: () => import('@mui/icons-material/WorkspacesFilled'),
  WrapText: () => import('@mui/icons-material/WrapText'),
  WrongLocation: () => import('@mui/icons-material/WrongLocation'),
  Wysiwyg: () => import('@mui/icons-material/Wysiwyg'),
  X: () => import('@mui/icons-material/X'),
  Yard: () => import('@mui/icons-material/Yard'),
  YouTube: () => import('@mui/icons-material/YouTube'),
  YoutubeSearchedFor: () => import('@mui/icons-material/YoutubeSearchedFor'),
  ZoomIn: () => import('@mui/icons-material/ZoomIn'),
  ZoomInMap: () => import('@mui/icons-material/ZoomInMap'),
  ZoomOut: () => import('@mui/icons-material/ZoomOut'),
  ZoomOutMap: () => import('@mui/icons-material/ZoomOutMap'),
};
